
import { Component, ElementRef, HostBinding, HostListener, OnInit, Input, OnChanges, SimpleChanges, ViewChild, Output, EventEmitter } from '@angular/core';
import { DialogService } from 'src/app/services/dialog.service';
import { FilterService } from 'src/app/services/filter.service';
import { ActivatedRoute, Router } from '@angular/router';
import { RouterHandlerService } from 'src/app/services/router-handler.service';
import { NavigationService } from 'src/app/services/navigation.service';

import { IconChartComponent } from '../iconEvent-chart/icon-chart.component';
import { NewFilterService } from 'src/app/services/new-filter.service';

import * as d3 from "d3";

interface period_data {
  period: string;
  kpi_value: number;
}

interface dqm_scatter_data {
  id: string;
  x: number;
  y: number;
  source_nm: string;
  kpi_name: string;
  kpi_key: number;
  lookback_period: number;
  periods: period_data;
  current_color?: string;
  kpi_value?: number;
  location?: string;
  location_key?: number;
  category?: string;
  current_date?: string;
  upper_control_limit: number;
  lower_control_limit: number;
  lower_threshold: number;
  upper_threshold: number;
  no_of_std_deviations: number;
  x_axis_value: any;
  x_axis_key: any;
  y_axis_value: any;
  y_axis_key: any;
}

@Component({
  selector: 'scatter-plot-chart',
  templateUrl: './scatter-plot-chart.component.html',
  styleUrls: ['./scatter-plot-chart.component.scss']
})
export class ScatterPlotChartComponent implements OnInit, OnChanges {

  @ViewChild('scatterPlotContainer', { static: true }) scatterPlotContainer!: ElementRef
  @ViewChild(IconChartComponent) iconChart!: IconChartComponent;
  @Input('item') item: any
  @Input('type') type: any
  @Input('data') data: any
  @Input('columnDetails') columnDetails: any
  @Input('config') config: any
  @Input('heading') heading: string = ''
  @Input('pageKey') pageKey: any
  @Input('error_name') error_name: any
  @Input('prefrenceConfig') prefrenceConfig: any
  @HostBinding('class.is-fullscreen') isFullscreen = false;

  // Data recieved from API calls
  ScatterPlotChartData: any = [];
  // main data structure used when 
  masterData: dqm_scatter_data[] = [];

  // Data currently rendered based on filters and zoom
  displayData: dqm_scatter_data[] = [];
  // TODO: change selectedPoints from elements to just holding the data


  haveSelectedPoints: boolean = false;
  // Stores the DOM elements selected by the user's drag/lasso action.
  selectedPoints: any = [];
  // stores the data behind the points we have zoomed into
  selectedPointsData: dqm_scatter_data[] = [];


  //Flag indicating if the chart is currently zoomed into a drag-selected area. */
  isZoomedToSelection: boolean = false;
  placePointsWithForce: boolean = true;
  showLabels: boolean = true;    // variable to see if we want to show labels on data points
  useForce: boolean = true;    // variable to see if we want points large and to have collision detection

  // info for irHeatMap
  HeatMapData: any = [];

  // info for scatter plot
  noData: boolean = false
  divId: any = "scatterPlotChartDiv";
  iconList: any;
  isActive = false;
  props: any = {};
  initiateChart: boolean = false;
  startDate: string = "";
  endDate: string = "";
  originalName: string = "";


  tooltip: any;
  mytooltipData: any;
  tooltipTurn: any;
  tooltipHeight: any;
  width: any;
  cardWidthWithoutScrolling: any;
  initialChartWidth: any;
  dotColors: any;

  selectedType: string = "anomaly";
  myCategories = new Set<string>();
  selectedCategories: string[] = [];
  maxNumberPoints: number = 10;

  xScale: any;
  yScale: any;
  xAxis: any; // Main X-axis scale for sources
  yAxis: any;
  yMin: number = 0;
  yMax: number = 0;
  subXScaleMap: any; // Map of scales for categories within each source
  subXScale: any;
  colorScale: any;

  upperBound = 2;
  lowerBound = -2;
  redFade: any;
  greenFade: any;
  blueFade: any;
  green: string = "#2dc887";
  red: string = "#e86e54";
  blue: string = "#655ade";
  gray: string = "#a2afbf";

  selectedValue: string = 'anomaly';
  sources: any = [];
  legendFilter: any = [];

  current_theme = this.selectedValue;
  known_source_colors: Record<string, string> = {}; // Maps source_nm to color
  known_kpi_colors: Record<string, string> = {}; // Maps kpi_name to color

  // ['#263DA3', '#1C0686', '#611C14']

  // categoryColorsMap: Record<string, string> = {"business": "#1363DF", "location": "#3DC5FF", "operational kpis": "#CAC171", "others": "#2DC887"}
  categoryColorsMap: Record<string, string> = {}
  categoryColors: string[] = [
    "#1363DF", // purple
    "#3DC5FF", // baby blue
    "#CAC171", // yellow
    "#FF00FF", // Magenta
    "#FFA500", // Orange
    "#FF8BA0", // Pink
    "#800000", // Maroon
    "#008080", // Teal
    "#FF7F50", // Coral (light orange)
    "#7A7979"  // Gray
  ];


  darkColors: string[] = [
    "#8B0000", // Dark Red
    "#228B22", // Forest Green
    "#008080", // Teal
    "#FF8C00", // Dark Orange
    "#9932CC", // Dark Orchid
    "#3B3B98", // Deep Blue
    "#483D8B", // Dark Slate Blue
    "#4B0082", // Indigo
    "#6A5ACD", // Slate Blue
    "#B03060", // Deep Pink/Crimson
    "#800080", // Purple
    "#4169E1", // Royal Blue
    "#556B2F", // Dark Olive Green
    "#A0522D", // Sienna
    "#5F9EA0", // Cadet Blue
    "#DC143C", // Crimson
    "#4682B4", // Steel Blue
    "#CD5C5C"  // Indian Red
  ];


  iconViewBox = '0 0 10 7';
  downIconPath = 'M0.313868 7H3.49922C3.67246 7 3.81309 6.85487 3.81309 6.67564V6.02045C3.81309 5.84142 3.67246 5.69609 3.49922 5.69609H2.15371L4.90684 2.8511L6.07402 4.05732C6.32051 4.31184 6.71992 4.31184 6.96641 4.05732L9.90801 1.01694C10.0307 0.890384 10.0307 0.684907 9.90801 0.558351L9.45977 0.0949173C9.3373 -0.0316386 9.13848 -0.0316386 9.01602 0.0949173L6.52012 2.67428L5.35313 1.46806C5.10666 1.21327 4.70719 1.21317 4.46074 1.46806L1.26172 4.77406V3.38356C1.26172 3.20453 1.12129 3.0592 0.947851 3.0592H0.313868C0.140429 3.0592 0 3.20453 0 3.38356V6.67564C0 6.85487 0.140429 7 0.313868 7Z';
  upIconPath = 'M9.68613 0H6.50078C6.32754 0 6.18691 0.145126 6.18691 0.324363V0.979549C6.18691 1.15858 6.32754 1.30391 6.50078 1.30391H7.84629L5.09316 4.1489L3.92598 2.94268C3.67949 2.68816 3.28008 2.68816 3.03359 2.94268L0.0919922 5.98306C-0.0306641 6.10962 -0.0306641 6.31509 0.0919922 6.44165L0.540234 6.90508C0.662695 7.03164 0.861523 7.03164 0.983984 6.90508L3.47988 4.32572L4.64687 5.53194C4.89334 5.78673 5.29281 5.78683 5.53926 5.53194L8.73828 2.22594V3.61644C8.73828 3.79547 8.87871 3.9408 9.05215 3.9408H9.68613C9.85957 3.9408 10 3.79547 10 3.61644V0.324363C10 0.145126 9.85957 0 9.68613 0Z';
  margins = { top: 15, right: 30, bottom: 30, left: 40, brush: 52, mid: 200, legend: 40 };

  // Vars to set up control chart
  clientKey: any
  moduleKey: any
  dashboardKey: any
  compare: any;
  moduleName: any;
  decryptedParams: any = {};
  queryParams: any;
  constructor(
    public dialogService: DialogService,
    public filterService: FilterService,
    private newFilterService: NewFilterService,
    private route: ActivatedRoute,
    private router: Router,
    private routerHandlerService: RouterHandlerService,
    private navigationService: NavigationService) {
    this.filterService.changeDisplays.subscribe((res: any) => {
      // gets the value of the selected toggle from the icon chart 
      this.changeDisplayType(res);
    });
    // This is used for setting up the route to the control chart
    this.route.params.subscribe((p: any) => {
      this.queryParams = p;
      this.moduleName = p['module'] || '';

      this.route.queryParams.subscribe((params: any) => {
        this.decryptedParams = this.navigationService.decryptData(params);
        this.clientKey = this.decryptedParams["cl_key"];
        this.moduleKey = this.decryptedParams["md_key"];
        this.dashboardKey = this.decryptedParams["ds_key"];
      });
    });

    // when the filter changes then start the loading animation process again
    this.filterService.filterQuery.subscribe(() => this.start());
  }

  @HostListener('fullscreenchange', ['$event'])
  @HostListener('webkitfullscreenchange', ['$event'])
  @HostListener('mozfullscreenchange', ['$event'])
  @HostListener('MSFullscreenChange', ['$event'])
  screenChange(event: any) {
    if (!document.fullscreenElement) {
      this.closeFullscreen();
    }
  }
  closeFullscreen(): void {
    this.isFullscreen = false;
    this.props.chartHeight = 400
    this.cardWidthWithoutScrolling = this.initialChartWidth;
    this.isActive = false;

    // if (document.exitFullscreen) {
    //   document.exitFullscreen();
    // } 
    setTimeout(() => {
      this.plotChart(false);
    }, 100);
  }
  //loade Method
  isLoading = false;
  async stop(ms: number): Promise<void> {
    return new Promise<void>(resolve => setTimeout(resolve, ms));
  }
  start() { this.isLoading = true; }

  // sends value selected sources and KPIs to HeatMap
  sendScatterPlotData(value: string) {
    console.log("sending...", value);
    this.newFilterService.scatterPlotData.next(value);
    // this.newFilterService.updateScatterPlotData(value);
  }

  // button handler that sends data to HeatMap 
  showDataHeatMap() {
    this.sendScatterPlotData(this.HeatMapData);
  }

  updateHeatMapData(points: any) {
    console.log("updating...");
    if (points.length != 0) {
      this.HeatMapData = points.map((point: any) => {
        // Get single data object for 1 point in points 
        const point_data: any = d3.select(point).datum();
        // just extract the source name, kpi name, and location
        return {
          source_name: point_data?.source_nm,
          kpi_name: point_data?.kpi_name,
          location_name: point_data?.location,
          lookback_period: point_data?.lookback_period,
          kpi_key: point_data?.kpi_key,
          x_axis_value: point_data?.x_axis_value,
          x_axis_key: point_data?.x_axis_key,
          y_axis_value: point_data?.y_axis_value,
          y_axis_key: point_data?.y_axis_key,
          no_of_std_deviations: point_data?.no_of_std_deviations
        }
      });
    }
    else {
      this.HeatMapData = [];
    }
  }

  // @HostListener('window:resize', ['$event'])
  // onWindowResize(event: any) {
  //   setTimeout(() => {
  //     this.plotChart(false)
  //   }, 100);
  // }

  ngOnInit(): void {
    this.iconList = this.item?.config.icon ? this.item?.config.icon : this.iconList
    this.start();
    this.initiateCharts();
  }
  ngOnChanges(changes: SimpleChanges): void {
    if (changes['data']?.currentValue != changes['data']?.previousValue && this.initiateChart) {
      this.getScatterPlotChartData();
    }
  }

  // 2. Create a method to toggle the state and re-render the chart.
  public toggleLabels(): void {
    this.showLabels = !this.showLabels; // Flip the boolean value
    this.renderPointsandBackgroundBands(this.displayData); // Re-run the render function to apply the change
  }
  // Create a method to toggle the state of useForce and re-render the chart.
  public toggleForce(): void {
    this.useForce = !this.useForce; // Flip the boolean value
    this.renderPointsandBackgroundBands(this.displayData); // Re-run the render function to apply the change
  }

  changeDisplayType(selectedType: any) {
    this.selectedType = selectedType;
    this.changeChartTheme(selectedType);
  }

  lookBackUsingDateFilter(arr: any) {
    if (arr) {
      sessionStorage.setItem("dashboardControl", JSON.stringify(arr));
    }
  }

  public compareClick(myType?: any, myData?: any, currentSelections?: any): void {
    // if (this.type != 'chart') {
    // sessionStorage.setItem("currentSelections", JSON.stringify(this.props.currentSelections));
    //   this.props.currentSelections = currentSelections
    // }
    // this.lookBackUsingDateFilter(this.item?.config?.db_pages_two)
    // modify current selections to match data for KPI breakdowns
    this.props.currentSelections = this.selectedPoints.map((point: any, idx: number) => {
      return {
        "x_axis_value": point.__data__.x_axis_value,
        "x_axis_key": point.__data__.x_axis_key,
        "y_axis_value": point.__data__.y_axis_value,
        "y_axis_key": point.__data__.y_axis_key,
        "index": idx + 1
      }
    });
    console.log("sending data to control chart");
    myData = {};
    myData['source_nm'] = [];
    myData[this.props.kpino] = [];
    myData["sp_location_key"] = [];
    myData["sp_location_name"] = [];
    myData["x_axis_key"] = [];
    myData["kpi_key"] = [];

    this.selectedPoints.forEach((val: any) => {
      // want to add kpi key and source name to myData
      console.log(val.__data__);
      let fndData = this.ScatterPlotChartData.find((o: any) => o["kpi_nm"]?.toString().toLowerCase() == val.__data__[this.props.columnVar]?.toString().toLowerCase());
      myData[this.props.kpino].push(fndData[this.props.kpino]);
      myData['source_nm'].push(val.__data__[this.props.secondLevelVar]);
      myData["sp_location_key"].push(val.__data__.location_key);
      myData["sp_location_name"].push(val.__data__.location);
      myData["x_axis_key"].push(val.__data__.x_axis_key);
      myData["kpi_key"].push(val.__data__.y_axis_key);
    });
    // remove duplicates in myData but keep it as an array
    myData['source_nm'] = [...new Set(myData['source_nm'])]
    // myData['x_axis_value'] = [...new Set(myData['x_axis_value'])]
    myData[this.props.kpino] = [...new Set(myData[this.props.kpino])]


    // Single node selected
    if (myType == "route" && this.props.currentSelections.length <= 1) {
      // myData['source_nm'] = myData['source_nm'].pop();
      // myData[this.props.kpino] = myData[this.props.kpino].pop();
      myData["sp_location_key"] = myData["sp_location_key"].pop();
      myData["sp_location_name"] = myData["sp_location_name"].pop();
      myData["x_axis_key"] = myData["x_axis_key"].pop();
      myData["kpi_key"] = myData["kpi_key"].pop();
      if (myData["sp_location_key"] === 0) {
        myData["sp_location_key"] = null;
      }
      console.log(myData);
      this.notCompareClick(myData);
      // this.dialogService.openSnackBar(`Select a minimum of 1 point and a max of ${this.maxNumberPoints}.`,"")
      return
    }
    // Comparing multiple nodes
    else if (myType == "route" && this.props.currentSelections.length > 1 && this.props.currentSelections.length < this.maxNumberPoints) {
      sessionStorage.setItem("currentSelections", JSON.stringify(this.props.currentSelections));

      // convert arrays to strings
      if (myData["sp_location_key"]) {
        myData["sp_location_key"] = myData["sp_location_key"]?.toString();
      }
      if (myData["sp_location_name"]) {
        myData["sp_location_name"] = myData["sp_location_name"]?.toString();
      }

      if (myData["x_axis_key"]) {
        myData["x_axis_key"] = myData["x_axis_key"]?.toString();
      }
      if (myData["kpi_key"]) {
        myData["kpi_key"] = myData["kpi_key"]?.toString();
      }
      let configPages = this.item?.['config'];
      if (configPages?.nav_configuration) {
        const config0 = configPages?.nav_configuration?.['controls'].find((o: any) => o.chartType.includes('Multi'));
        this.type = 'widget';
        if (this.type != undefined && this.type != 'chart') {
          this.navigationImplementation(config0, 'multi', myData);
          sessionStorage.setItem('multiChartControlItemConfig', JSON.stringify(config0))
          this.routerHandlerService.storingPayloadAndFilterForGrid(config0, myData, '');
        }
      } else {
        let storeConfigred: any = sessionStorage.getItem('multiChartControlItemConfig');
        storeConfigred = JSON.parse(storeConfigred);
        this.routerHandlerService.storingPayloadAndFilterForGrid(storeConfigred, myData, '');
      }
      // sessionStorage.setItem("selectedKPIcontrol", JSON.stringify(myData));
      // this.router.navigate([`dashboard/${this.clientKey}/${this.moduleKey}/${this.dashboardKey}/comparison/multi`], { queryParams: myData, queryParamsHandling: 'merge', skipLocationChange: false });

      if (this.type == 'chart') {

        // this.filterService.duplicateParameter
        let updatesObj: any = Object.entries(myData).map(([key, value]) => ({ key, value }));
        if (updatesObj.length) {
          for (let idx = 0; idx < updatesObj.length; idx++) {
            let whole: any = Object.entries(this.filterService.backupAllSingleAndMulti).map(([key, value]) => ({ key, value }));
            if (whole.length) {
              let fndData = whole.find((fnd: any) => fnd.key == updatesObj[idx].key)
              if (fndData) {
                let flrData = fndData.value.filter((f: any) => updatesObj[idx].value.find((o: any) => o == f[fndData.key]))
                this.filterService.previousModel[updatesObj[idx].key] = flrData.length ? flrData : this.filterService.previousModel[updatesObj[idx].key]

                if (updatesObj[idx].key == 'source_nm') {
                  this.filterService.duplicateParameter['source_key'] = ""
                  flrData.forEach((lo: any) => {
                    this.filterService.duplicateParameter['source_key'] += lo.source_key + ','
                  })

                  this.filterService.duplicateParameter['source_key'].slice(0,
                    this.filterService.duplicateParameter['source_key'].lastIndexOf(","));
                }

              }
            }
          }
          this.filterService.setFilterValue(this.filterService.previousModel, this.queryParams);

        }
        // this.filterService.resetFilter();
        // window.location.reload();

      }

    } else if (myType == "route" && this.props.currentSelections.length > this.maxNumberPoints) {
      this.dialogService.openSnackBar(` Do not select more than ${this.maxNumberPoints} nodes`, "");
    }
  }

  // when a single node is compared
  private notCompareClick(myData: any): void {
    if (myData["sp_location_key"]) {
      myData["sp_location_key"] = myData["sp_location_key"]?.toString();
    }

    let config = this.item?.['config'];
    if (config?.nav_configuration) {
      const config0 = config?.nav_configuration?.['controls'].find((o: any) => o.chartType.includes('Single'));
      this.navigationImplementation(config0, 'single', myData)
      this.routerHandlerService.storingPayloadAndFilterForGrid(config0, myData, '');
    }
    // this.router.navigate([`dashboard/${this.clientKey}/${this.moduleKey}/${this.dashboardKey}/comparison/single`], { queryParams: query, queryParamsHandling: 'merge', skipLocationChange: false });
  }

  navigationImplementation(config0: any, cardId: any, myData: any) {
    let nav = {
      dbJSON: config0?.dbJSON,
      s3JSON: config0?.s3JSON,
      pageName: config0?.pageName,
      isDashboardLevel: config0?.isDashboardLevel
    }
    this.lookBackUsingDateFilter(config0?.dbJSON);
    sessionStorage.setItem("navDetailInfo", JSON.stringify(nav));

    let selectedFilter = '';
    for (let key in myData) {
      selectedFilter += myData[key]?.toString?.() ?? '';
    }

    let query: any = Object.assign({}, this.decryptedParams, { cardId: cardId }, { tab_id: 0 }, { f_q: selectedFilter })
    let queryMaped = this.navigationService.movePropertyToFirst(query, 'tab_id');
    this.navigationService.routerNavigate(`dashboard/${this.moduleName}/${'comparison'}`, queryMaped);
  }


  //  d3 chart initial structure
  initiateCharts(): void {
    // only need to call this once on initialisation
    const myChart = this;
    const myClass = myChart.divId;

    this.originalName = this.item.config.widget_header_config.find((d: any) => d.name == "Page Header").page_header_name

    const mySvg = d3.select(this.scatterPlotContainer.nativeElement)
      .append('svg')
      .attr('id', 'svg_' + myClass)
      .attr("width", '100%')
      .style('background-color', 'white')
      .style("touch-action", "none");

    // used to keep the lasso drawing just to the bounds of the chart
    const defs = mySvg.append('defs');
    defs.append('clipPath').attr('id', 'lassoClip' + myClass)
      .append('rect').attr('id', 'lassoClipRect' + myClass);

    mySvg.append("g").attr("class", "xAxis" + myClass + " grid");
    mySvg.append("g").attr("class", "yAxis" + myClass + " grid");
    mySvg.append('g').attr('id', 'legendGroup' + myClass);
    mySvg.append("line").attr("id", "topLine");
    mySvg.append("g").attr("class", "lasso-layer");

    const chartArea = mySvg.append("g").attr("id", "chartArea" + myClass);
    chartArea.append("g").attr("id", "dotGroup");

    const legendSvg = d3.select("#scatterLegendDiv");

    // left legend Items
    const leftLegendSvg = legendSvg.insert('svg', '#chartToggles')
      .attr('class', 'left_svg_legendDiv' + myClass)
      .style('flex', '1')
      .style('width', '100%')
      .style('background-color', 'white');
    leftLegendSvg.append('circle').attr('class', 'legendArrowLeftItem' + myClass + ' legendArrowCircleLeft' + myClass);
    leftLegendSvg.append('text').attr('class', 'legendArrowLeftItem' + myClass + ' legendArrowLeft' + myClass);
    leftLegendSvg.append('circle').attr('class', 'legendArrowRightItem' + myClass + ' legendArrowCircleRight' + myClass);
    leftLegendSvg.append('text').attr('class', 'legendArrowRightItem' + myClass + ' legendArrowRight' + myClass);

    // right legend items
    const rightLegendSvg = legendSvg.append('svg')
      .attr('class', 'right_svg_legendDiv' + myClass)
      .style('flex', '1')
      .style('width', '100%')
      .style('background-color', 'white');
    rightLegendSvg.append('circle').attr('class', 'legendArrowLeftItem' + myClass + ' legendArrowCircleLeft' + myClass);
    rightLegendSvg.append('text').attr('class', 'legendArrowLeftItem' + myClass + ' legendArrowLeft' + myClass);
    rightLegendSvg.append('circle').attr('class', 'legendArrowRightItem' + myClass + ' legendArrowCircleRight' + myClass);
    rightLegendSvg.append('text').attr('class', 'legendArrowRightItem' + myClass + ' legendArrowRight' + myClass);

    // Elements for the line going across zero and the shaded box
    mySvg.append("line").attr("class", "zeroLine");
    mySvg.append("text").attr("class", "zeroLineLabel");
    mySvg.append("rect").attr("class", "zeroBox");

    // elements for Dip and Spike labels
    mySvg.select(".yAxis" + myClass)
      .append("text")
      .attr("class", "yAxis" + myClass + "-label" + " spike-label");

    mySvg.select(".yAxis" + myClass)
      .append("text")
      .attr("class", "yAxis" + myClass + "-label" + " dip-label");



    // My tooltip for words that are too small to show 
    const tooltipGroup = mySvg.append('g').attr('id', 'tooltipGroup' + myClass);
    tooltipGroup.append('rect').attr('class', 'wrapTooltipRect' + myClass);
    tooltipGroup.append('text').attr('class', 'wrapTooltipLabel' + myClass);

    this.initiateChart = true
    if (this.type == 'chart') {
      this.getScatterPlotChartData();
    }
  }


  getScatterPlotChartData() {
    let extracolor: any = this.getRandomColor(500);
    this.ScatterPlotChartData = this.data;

    this.maxNumberPoints = this.item.config?.['maxComparison'] || 10;


    this.props = {
      columnVar: "kpi_name",
      kpino: 'kpi_key',
      secondLevelVar: 'source_nm',
      "darkColors": this.item.config.list_of_api?.api_key == 3005 ? ["#E74028", "#2CB239", "#25D3EB", "#FFB039", "#1566DE", "#7848FF", "#7AD045", "#CB04DC", "#FA195C", "#9E0000", "#EACD37", "#DD630B", "#BCD03F", "#14BDA9", "#8A05F3", "#D9476A", "#2DADB6", "#E468C2", "#199CD4", "#0934CC",
        "#e74c3c", "#3498db", "#2ecc71", "#f1c40f", "#9b59b6",
        "#1abc9c", "#34495e", "#e67e22", "#16a085", "#d35400",
        "#2980b9", "#8e44ad", "#c0392b", "#27ae60", "#f39c12",
        "#7f8c8d", "#e74c3c", "#3498db", "#2ecc71", "#f1c40f",
        "#9b59b6", "#1abc9c", "#34495e", "#e67e22", "#16a085",
        "#d35400", "#2980b9", "#8e44ad", "#c0392b", "#27ae60",
        "#f39c12", "#7f8c8d", "#e74c3c", "#3498db", "#2ecc71",
        "#f1c40f", "#9b59b6", "#1abc9c", "#34495e", "#e67e22",
        "#16a085", "#d35400", "#2980b9", "#8e44ad", "#c0392b",
        "#27ae60", "#f39c12", "#7f8c8d",
      ] : ["#E74028", "#2CB239", "#25D3EB", "#FFB039", "#1566DE", "#7848FF", "#7AD045", "#CB04DC", "#FA195C", "#9E0000", "#EACD37", "#DD630B", "#BCD03F", "#14BDA9", "#8A05F3", "#D9476A", "#2DADB6", "#E468C2", "#199CD4", "#0934CC", '#1F2B97', '#2B6BCB', '#2F3CAF', '#3E85EF', '#404CBB', '#4832A1', '#49ACA0', '#58B3B9', '#5EDE6B', '#663DBC', '#6651BE', '#6BCFDD', '#7458E7', '#7559C5', '#81B661', '#B04747', '#BB3847', '#BBAB54', '#BFC23D', '#C45B0F', '#C75FD0', '#D0662A', '#D25297', '#DD6287', '#DE7D48', '#E29063', '#FF5740', '#FFC164', ...extracolor],
      "lightColors": this.item.config.list_of_api?.api_key == 3005 ? ["#E74028", "#2CB239", "#25D3EB", "#FFB039", "#1566DE", "#7848FF", "#7AD045", "#CB04DC", "#FA195C", "#9E0000", "#EACD37", "#DD630B", "#BCD03F", "#14BDA9", "#8A05F3", "#D9476A", "#2DADB6", "#E468C2", "#199CD4", "#0934CC",
        "#e74c3c", "#3498db", "#2ecc71", "#f1c40f", "#9b59b6",
        "#1abc9c", "#34495e", "#e67e22", "#16a085", "#d35400",
        "#2980b9", "#8e44ad", "#c0392b", "#27ae60", "#f39c12",
        "#7f8c8d", "#e74c3c", "#3498db", "#2ecc71", "#f1c40f",
        "#9b59b6", "#1abc9c", "#34495e", "#e67e22", "#16a085",
        "#d35400", "#2980b9", "#8e44ad", "#c0392b", "#27ae60",
        "#f39c12", "#7f8c8d", "#e74c3c", "#3498db", "#2ecc71",
        "#f1c40f", "#9b59b6", "#1abc9c", "#34495e", "#e67e22",
        "#16a085", "#d35400", "#2980b9", "#8e44ad", "#c0392b",
        "#27ae60", "#f39c12", "#7f8c8d",
      ] : ["#F29F93", "#95D89C", "#92E9F5", "#FFD79C", "#8AB2EE", "#BBA4FF", "#BCE8A2", "#E581ED", "#FC8CAD", "#CF8080", "#F4E69B", "#EEB185", "#DDE89F", "#89DED4", "#C582F9", "#ECA3B5", "#96D6DA", "#F1B3E0", "#8CCDE9", "#8399E5", '#7181b4', '#82a4e1', '#8a9dd5', '#9db5f4', '#9f8dc8', '#a47fa7', '#a8d2c7', '#b5d3d6', '#c3e69b', '#cda6e1', '#cda4e3', '#d7f4f8', '#dcb9f1', '#dcc9e3', '#aadcbf', '#e08685', '#ec9a97', '#ecd2ad', '#f1f0c5', '#f3c7af', '#f4c9f0', '#f8d4be', '#f8c7e3', '#fdd6d7', '#fddbcb', '#f7e2d8', '#ffadab', '#ffd3aa', ...extracolor],
      period:
        this.item.config.list_of_api.api_key == 100196
          ? "PCQ"
          : this.filterService.report_type || "D",
      // xAxisLabel: this.config.xAxisLabel,
      // yAxisLabel: this.config.yAxisLabel,
      // xAxisVar: this.config.xAxisVar,
      // yAxisVar: this.config.yAxisVar,
      // secondYVar: this.config.secondary_value_column || null,
      showBrush: true,
      d3AxisFormatting: false,
      yAxisFormatting: "-2~s",
      // groupVar:   this.filterService.showByKey=='N'?this.config.show_by_ndc:this.config.value_column,
      displayType: this.selectedType,
      axisFontSize: 12,
      axisFontWeight: 700,
      axisRotation: -45,
      chartHeight: 400,
      circeValveShow: true,
      circeValveFontSize: 12,
      circeValveBold: false,
      circeValveColor: "#101D42",
      xAxisShow: true,
      xAxisFontSize: 12,
      xAxisBold: false,
      xAxisColor: "#101D42",
      LabelfontSize: 10,
      Labelcolor: "#101D42",
      Labelbackground: true,
      LabelbackgroundColor: "#fff",
      partialPeriod:
        this.item.config.list_of_api.api_key == 100196 ? false : true,
      // chartBrushAndPercents:
      //   this.config.secondary_value_column ||
      //     this.item.config.list_of_api.api_key == 100196
      //     ? false
      //     : true,
      currentSelections: [],
      showAreaLegend: false,
      areaLabels: {
        line: "Inventory Quantity",
        dottedLine: " Shipment Quantity",
      },
      "showGaps": true,
      "slider": this.item.config?.['zoom_slider']?.value == 'true' || false,
      "yBrush": false//this.item.config?.vertical_brush?.value == "true" ? true : false
    };


    if (this.ScatterPlotChartData.length > 0) {
      this.noData = false;
      setTimeout(() => {
        // if (this.type == 'chart') {
        //   let currentSelections: any = sessionStorage.getItem("currentSelections");
        //   this.props.currentSelections = JSON.parse(currentSelections);
        //   this.props.showSelections = true
        // }
        let mySvg = d3.select(this.scatterPlotContainer.nativeElement)
        this.cardWidthWithoutScrolling = mySvg.node()?.getBoundingClientRect().width ?? 600;
        this.initialChartWidth = this.cardWidthWithoutScrolling;
        let currentDate;
        let ucl = 0;
        let lcl = 0;
        // Go through data and add in the Z score
        this.ScatterPlotChartData.forEach((entry: any) => {
          if (entry["periods"]) {
            let stdev = entry?.no_of_std_deviations ?? 2;
            let valuesToLookCalculate = JSON.parse(JSON.stringify(entry["periods"]));
            // let valuesToLookCalculate = entry["periods"];
            // remove most recent data point
            const currentData = valuesToLookCalculate.pop()
            entry["current_date"] = currentData?.period;
            entry["kpi_value"] = currentData?.kpi_value;
            if (valuesToLookCalculate.length > 0) {
              valuesToLookCalculate = valuesToLookCalculate.slice(-entry["look_back_period"]);
              const sum = valuesToLookCalculate.reduce((acc: any, val: any) => acc + val["kpi_value"], 0);
              let avg = sum / valuesToLookCalculate.length;
              const squaredDifferences = valuesToLookCalculate.map((val: any) => Math.pow(val["kpi_value"] - avg, 2));
              const sumOfSquaredDifferences = squaredDifferences.reduce((acc: any, val: any) => acc + val, 0);
              const variance = sumOfSquaredDifferences / valuesToLookCalculate.length;
              var dev = Math.sqrt(variance);
              lcl = avg - (stdev * dev);
              ucl = avg + (stdev * dev);
              lcl < 0 ? lcl = 0 : lcl;
              ucl < 0 ? ucl = 0 : ucl;
              if (dev != 0) {
                // (current data point - the average of previous data points) / (standard deviation of previous data points) 
                const z_score = ((entry["kpi_value"] - avg) / dev).toFixed(4);
                entry["z_score"] = z_score;
              }
              else {
                entry["z_score"] = 0;
              }
            }
            else {
              entry["z_score"] = 0;
            }
          }
          else {
            entry["periods"] = [];
            entry["z_score"] = 0;
            entry["current_date"] = "unknown";
          }
          entry["lower_control_limit"] = lcl;
          entry["upper_control_limit"] = ucl;
        });

        let frm_dt = this.filterService.baseQuery?.['from_date'] || '';
        if (frm_dt) {
          this.ScatterPlotChartData = this.ScatterPlotChartData.filter((item: any) => new Date(item.current_date) >= new Date(frm_dt + 'T00:00:00'));
        }

        if (this.ScatterPlotChartData.length == 0) {
          this.noData = true;
        }
        // console.log(this.ScatterPlotChartData)
        this.isLoading = false;
        // Ensure child component receives reference
        // if (this.iconChart) {
        //   this.iconChart.scatterPlotRef = this;
        //   const myDateBadge = this.filterService.badges.find(d => d.key =="time_single_date");
        //   this.startDate = myDateBadge.value;
        //   this.endDate = myDateBadge.length;
        //   this.item.config.widget_header_config.find((d:any) => d.name == "Page Header").page_header_name = this.originalName;
        //   if(this.startDate && this.endDate){
        //     this.item.config.widget_header_config.find((d:any) => d.name == "Page Header").page_header_name += `: ${this.startDate} - ${this.endDate}`
        //   }
        // }
        this.legendFilter = [];
        if (Object.keys(this.prefrenceConfig||{}).length > 0) {
          this.applyChartPreferences(this.prefrenceConfig);
        } else {
          this.plotChart();
        }
      }, 500);
    } else {
      this.stop(10).then(() => this.isLoading = false);
      this.noData = true;
    }
  }

  // Default value
  // onValueChange() {
  //   this.changeChartTheme(this.selectedValue);
  // }

  getContrastColor(hexColor: string): string {
    // Convert hex to RGB
    const r = parseInt(hexColor.substr(1, 2), 16);
    const g = parseInt(hexColor.substr(3, 2), 16);
    const b = parseInt(hexColor.substr(5, 2), 16);

    // Calculate luminance
    const yiq = ((r * 299) + (g * 587) + (b * 114)) / 1000;

    // Return black or white based on luminance
    return (yiq >= 128) ? 'black' : 'white';
  }

  getPointOpacity(d: any): number {
    if (this.current_theme === 'kpi' || this.current_theme === 'sp') {
      return 0.5;
    } else {
      // anomaly or deviation
      if (d.y > this.upperBound) {
        return this.redFade(d.y);
      } else if (d.y < this.lowerBound) {
        return this.blueFade(d.y);
      } else {    // between lower and upperbound
        return this.greenFade(Math.abs(d.y));
      }
    }
  }

  getEffectiveColor(hexColor: string, opacity: number): string {
    // Convert hex to RGB
    const r = parseInt(hexColor.substr(1, 2), 16);
    const g = parseInt(hexColor.substr(3, 2), 16);
    const b = parseInt(hexColor.substr(5, 2), 16);

    // Calculate effective RGB assuming white background (255, 255, 255)
    // C_eff = C_src * alpha + C_bg * (1 - alpha)
    const rEff = Math.round(r * opacity + 255 * (1 - opacity));
    const gEff = Math.round(g * opacity + 255 * (1 - opacity));
    const bEff = Math.round(b * opacity + 255 * (1 - opacity));

    // Convert back to hex
    return "#" + ((1 << 24) + (rEff << 16) + (gEff << 8) + bEff).toString(16).slice(1);
  }

  getPointColor(d: any): string {
    if (this.current_theme === 'kpi') {
      return this.known_kpi_colors[d.kpi_name] || "gray";
    } else {
      // anomaly or deviation
      if (d.y > this.upperBound) return this.red;
      if (d.y < this.lowerBound) return this.blue;
      return this.green;
    }
  }

  setAnomalyThemeColors() {
    // set up gradient fades on data points
    const myChart = this;
    d3.selectAll(".point-group").each(function (d: any) {
      const group = d3.select(this);
      const circle = group.select(".data_point");
      const text = group.select(".kpi-value-text");

      const color = myChart.getPointColor(d);
      const opacity = myChart.getPointOpacity(d);

      circle
        .attr("style", null)
        .attr("fill", color)
        .attr("fill-opacity", opacity)
        .attr("stroke", color);

      const effectiveColor = myChart.getEffectiveColor(color, opacity);
      text.style("fill", myChart.props.circeValveColor || myChart.getContrastColor(effectiveColor));
    });
  }

  setKPIThemeColors() {
    const myChart = this;
    d3.selectAll(".point-group").each(function (d: any) {
      const group = d3.select(this);
      const circle = group.select(".data_point");
      const text = group.select(".kpi-value-text");

      const color = myChart.getPointColor(d);
      const opacity = 0.5; // Fixed opacity for KPI theme

      circle
        .attr("style", null)
        .attr("fill", color)
        .attr("fill-opacity", opacity)
        .attr("stroke", color)
        .attr("stroke-width", "1px");

      const effectiveColor = myChart.getEffectiveColor(color, opacity);
      text.style("fill", myChart.props.circeValveColor || myChart.getContrastColor(effectiveColor));
    });
  }

  // Theme is the overall toggle selection
  changeChartTheme(theme: string) {
    // Make sure lasso is removed and that mouse buttons are not visible
    let mySvg = d3.select(this.scatterPlotContainer.nativeElement)
    mySvg.select(".lasso-layer").selectAll("path").remove();
    this.hideMouseButtons();


    if (theme === "anomaly" || theme === "deviation") {

      // just get the names and colors of desired subcategories set in the designer/ filter
      // const currentCategoryColors = this.selectedCategories.reduce((acc:any, key:any) =>{
      //   if (key in this.categoryColorsMap) acc[key] = this.categoryColorsMap[key]
      //   return acc;
      // }, {});
      // update legend
      this.drawLegend(this.updateLegendItems(this.categoryColorsMap, "right"), "right");
      this.drawLegend(this.updateLegendItems(this.categoryColorsMap, "right"), "right");
      this.drawLegend(this.updateLegendItems({ "normal": this.green, "dip": this.blue, "spike": this.red }, "left", false));

      this.current_theme = theme;

      // make sure y axis gradient bar is shown
      d3.selectAll(".y-gradient-step")
        .attr('visibility', 'visible');

      this.setAnomalyThemeColors();

    }
    else {
      // make sure y axis gradient bar is not shown
      d3.selectAll(".y-gradient-step")
        .attr('visibility', 'hidden');


      if (theme === "sp") {
        this.current_theme = theme;
        d3.selectAll(".data_point")
          .attr("style", null)
          .attr("style", null)
          .attr("fill", (d: any) => this.known_source_colors[d.source_name] || "gray")
          .attr("fill-opacity", 0.5)
          .attr("stroke", (d: any) => this.known_source_colors[d.source_name] || "gray")
          .attr("stroke-width", "1px");
      }
      else if (theme === "kpi") {
        this.current_theme = theme;
        // update left legend to show KPIs
        // need to get current KPI from data
        this.drawLegend(this.updateLegendItems(this.known_kpi_colors));

        // set the circle colors to the KPI theme
        this.setKPIThemeColors();
      }
    }
  }


  getAnomalyStatus(yVal: number) {
    if (yVal > this.upperBound) {
      return "spike"
    }
    else if (yVal < this.lowerBound) {
      return "dip"
    }
    else {       // in between upper and lower bounds
      return "normal"
    }
  }

  updateDataViaLegendFilter(theme: string) {
    if (this.legendFilter.length === 0) {
      // we are zoomed in and the legend is zero
      if (this.isZoomedToSelection) {
        this.displayData = this.selectedPointsData;
      }
      else {
        // No legend labels selected, show all data
        this.displayData = [...this.masterData];
      }
    }
    else {
      if (this.isZoomedToSelection) {
        // if we are zoomed in then filter based off of selectedPointsData
        this.displayData = this.selectedPointsData.filter(d => !(this.legendFilter.includes(this.getAnomalyStatus(d.y)) || this.legendFilter.includes(d.kpi_name)));
      }
      else {
        this.displayData = this.masterData.filter(d => !(this.legendFilter.includes(this.getAnomalyStatus(d.y)) || this.legendFilter.includes(d.kpi_name)));
      }
    }
  }

  filterPointsViaLegend() {
    const myChart = this;

    this.updateDataViaLegendFilter(this.current_theme);

    myChart.updateScalesAndDomains();
    if (!this.noData) {
      setTimeout(() => {
        myChart.renderPointsandBackgroundBands(this.displayData);
        myChart.zoomIntoSelectedPoints(this.displayData, false);
        this.current_theme === "anomaly" ? myChart.setAnomalyThemeColors() : myChart.setKPIThemeColors();
      }, 0);
    }

  }

  drawLegend(myLegendItems: any, side: string = "left"): void {
    const myChart = this;
    const myClass = myChart.divId;
    const mySvg: any = d3.select('#svg_' + myClass);

    const legendToolTip: any = d3.select('#legendToolTip')

    const legendSvg: any = d3.select(`.${side}_svg_legendDiv` + myClass);
    legendSvg.attr('transform', `translate(5,0)`);
    // make sure legend group is in the center of div
    const svgHeight = parseFloat(legendSvg.attr('height') || '40');
    const groupHeight = 17;
    const centerY = (svgHeight - groupHeight) / 2;

    const legendGroup = legendSvg
      .selectAll('.legendGroup' + myClass)
      .data(myLegendItems)
      .join((group: any) => {
        const enter = group.append('g').attr('class', 'legendGroup' + myClass);
        enter.append('rect').attr('class', 'legend-hitbox'); // this is for setting styles when hovering over group
        enter.append('circle').attr('class', 'legendCircle');
        enter.append('text').attr('class', 'legendLabel' + myClass);
        // cannot remember if you have seen the way I am using icons before or not
        // it is an svg (which gets positioned/sized) with a path (which gets icon properties and the path)
        return enter;
      });

    // fill should be based off of legend filter
    legendGroup.select('.legendCircle')
      .attr('id', (d: any) => 'circle_legendItem' + d.index + myClass)
      .attr('cy', this.margins.legend - 20)
      .attr('fill', (d: any) => this.legendFilter.includes(d.value) ? "none" : this.dotColors[d.value]) // have legend circle not filled in if value is in legendFilter
      .attr('stroke', (d: any) => this.legendFilter.includes(d.value) ? this.dotColors[d.value] : "none")
      .attr('stroke-width', (d: any) => this.legendFilter.includes(d.value) ? 2 : 0)
      .attr('r', 6);


    legendGroup.select('.legendLabel' + myClass)
      .attr('id', (d: any) => 'legendItem' + d.index + myClass)
      .attr('y', this.margins.legend - 15)
      .attr('fill', '#101D42')
      .attr('font-weight', '500')
      .attr('font-size', '12')
      .attr('font-family', 'Poppins')
      .attr('opacity', 1)
      .text((d: any) => d.label.toUpperCase())
      .on('mousemove', (event: any, d: any) => {
        const [mouseX, mouseY] = d3.pointer(event, mySvg.node());
        mySvg.select('.wrapTooltipLabel' + myClass).text('');
        if (d.label.includes('..')) {
          legendToolTip
            .style('display', 'flex')
            .style('left', `${mouseX - 15}px`)
            .style('top', `${mouseY + 70}px`)
            .style('white-space', 'nowrap')
            .text(d.value);
        }
      })
      .on('mouseout', () => {
        legendToolTip.style('display', 'none');
      });


    // Add dynamic filter for the left legend
    if (side === "left") {
      legendGroup.on('click', (event: any, d: any) => {
        // Add the legend value to the legendFilter if it does not exist in it
        // if we already have the value then remove it from the array
        let inFilter = false;
        if (this.legendFilter.includes(d.value)) {
          this.legendFilter = this.legendFilter.filter((item: any) => item !== d.value); // remove it
          inFilter = false;
        } else {
          this.legendFilter.push(d.value); // add it
          inFilter = true;
        }

        this.filterPointsViaLegend();
        // update legend with the changed legend filter depending on current theme
        d3.select(event.currentTarget).select('.legendCircle')
          .attr('fill', inFilter ? "none" : this.dotColors[d.value])
          .attr('stroke', inFilter ? this.dotColors[d.value] : "none")
          .attr('stroke-width', inFilter ? 2 : 0);

        d3.select(event.currentTarget).select('.legendLabel' + myClass)
          .attr('opacity', inFilter ? 0.6 : 1);
      })
    }

    let legendX = 60;
    // condition to the legend to be right aligned
    if (side == "right") {
      // fill should be based off category colors
      // legendGroup.select('.legendCircle')
      //     .attr('fill', (d:any) => this.legendFilter.includes(d.value) ? "none" : this.dotColors[d.value]) // have legend circle not filled in if value is in legendFilter
      //     .attr('r', 6);
      const svgWidth = parseFloat(legendSvg.node()?.getBoundingClientRect().width || '600');
      // Step 1: calculate total width of all legend items
      let totalWidth = 0;
      myLegendItems.forEach((d: any) => {
        totalWidth += (d.length + 35); // text + padding + circle + margin
      });
      // Step 2: set initial legendX to align all to the right
      legendX = svgWidth - totalWidth;
    }
    legendSvg.selectAll('.legendLabel' + myClass).each(function (this: SVGTextElement, d: any): any {
      const myId = this.id;
      d3.select(this).attr('x', legendX);
      legendSvg.select('#circle_' + myId)
        .attr('cx', legendX - 8 - 6)
        .attr('opacity', side === "right" ? 0.2 : 1);
      legendX += (35 + d.length);
    });
    // Now, size and position the hitboxes
    legendGroup.each(function (this: SVGGElement, d: any) {
      const group = d3.select(this);
      const label: any = group.select<SVGTextElement>('.legendLabel' + myClass);
      const circle = group.select<SVGCircleElement>('.legendCircle');

      if (label.node() && circle.node()) {
        // Get the calculated positions and sizes
        const labelX = parseFloat(label.attr('x'));
        // Use getComputedTextLength() for the accurate rendered width of the text
        const labelWidth = label.node().getComputedTextLength();
        const circleX = parseFloat(circle.attr('cx'));
        const circleR = parseFloat(circle.attr('r'));

        // Define the bounding box for the hitbox
        const PADDING = 4; // Add some padding for a better user experience
        const boxX = circleX - circleR - PADDING;
        const boxY = parseFloat(circle.attr('cy')) - 10 - PADDING; // Vertically center around your elements
        const boxWidth = (labelX + labelWidth) - boxX + (2 * PADDING);
        const boxHeight = 20 + (2 * PADDING); // A static height covering both elements

        group.select('.legend-hitbox')
          .attr('x', boxX)
          .attr('y', boxY)
          .attr('width', boxWidth)
          .attr('height', boxHeight)
          .attr('fill', 'transparent'); // Crucially, use 'transparent' not 'none'
      }
    });

    if (side == "left") {
      // Your existing mouseover/mouseout logic will now work perfectly
      legendGroup
        .on("mouseover", function (this: SVGGElement) {
          const group = d3.select(this);
          group.style('cursor', 'pointer');

          // This will now trigger anywhere over the hitbox area
          group.select('.legendCircle').attr('r', 7);
          group.select('.legendLabel' + myClass).attr('font-weight', 'bold');
        })
        .on("mouseout", function (this: SVGGElement) {
          const group = d3.select(this);
          group.style('cursor', 'default');

          group.select('.legendCircle').attr('r', 6);
          group.select('.legendLabel' + myClass).attr('font-weight', '500');
        });
    }

  }

  // update data structure and add other values to be used when drawing the legend
  updateLegendItems(legendItemsAndColors: any, side: string = "left", useFixedLength: boolean = true) {
    const myChart = this;
    const myClass = myChart.divId;
    // legend code taken from line-chart.component.ts, but with some tweeks
    const maxCharacters = 12;
    const legendMargins = 60;
    //set dot colors in drawLegend function
    this.dotColors = legendItemsAndColors;

    //legend items are the lineColor keys - might be something different in other charts
    let legendItems: any = Object.keys(legendItemsAndColors);

    const fixedItemWidth = 150;
    const maxTextWidth = fixedItemWidth - 40; // 40 for circle and padding

    if (useFixedLength) {
      // remapping them so that there is an index, value + label
      legendItems = legendItems.map((m: any, i: any) => {
        let label = m;
        // Check if label needs truncation
        if (measureWidth(label.toUpperCase(), 12) > maxTextWidth) {
          let truncated = label;
          while (truncated.length > 0 && measureWidth(truncated.toUpperCase() + '..', 12) > maxTextWidth) {
            truncated = truncated.slice(0, -1);
          }
          label = truncated + '..';
        }

        return {
          index: i,
          value: m,
          label: label,
          length: maxTextWidth, // Fixed length for uniform spacing
          valueLength: measureWidth(m.toUpperCase(), 10)
        };
      });
    } else {
      // Variable length logic
      legendItems = legendItems.map((m: any, i: any) => m = { index: i, value: m, label: (m.length > maxCharacters ? m.substr(0, maxCharacters).trim() + '..' : m) });
      // using measure width to map the length of the label AND the value.
      legendItems.map((m: any) => m.length = measureWidth(m.label.toUpperCase(), 12));
      legendItems.map((m: any) => m.valueLength = measureWidth(m.value.toUpperCase(), 10));
    }

    // so the width of the legend with ALL items is the length (set above) of each item + 40 (room for circle and spacing)
    const allLegendsWidth = d3.sum(legendItems, (s: any) => s.length + 40)
    let currentLegendItems = legendItems;
    // it starts by assuming all items fit
    let legendIndexLeft = 0;
    let legendIndexRight = legendItems.length - 1;
    // left arrow is always hidden initially (we are starting from the beginning)

    const legendSvg: any = side == "left" ? d3.select('.left_svg_legendDiv' + myClass) : d3.select('.right_svg_legendDiv' + myClass);
    const legendWidth: number = (legendSvg.node()?.getBoundingClientRect().width);
    console.log(`allLegendWidth: ${allLegendsWidth}`);
    console.log(`LegendWidth: ${legendWidth}`);
    let shownLegendsWidth = 0;
    let updateOnce = true;
    if (allLegendsWidth >= (legendWidth - legendMargins)) {
      // otherwise, the legend does not fit!!!
      currentLegendItems = [];
      let currentWidth = 0;
      // loop through all the legend items, aggregating the width UNTIL they don't fit anymore
      // legendIndexRight is the last one which fits.
      // anything after that is NOT stored in currentLegendItems and NOT visible
      legendItems.forEach((d: any, i: any) => {
        currentWidth += (d.length + 40);
        if (currentWidth < ((legendWidth) - legendMargins)) {
          legendIndexRight = i;
          currentLegendItems.push(d);
        }
        // get the shown legends width by only going through this once
        else if (currentWidth >= ((legendWidth) - legendMargins) && updateOnce) {
          shownLegendsWidth = currentWidth - (d.length + 40);
          updateOnce = false;
        }
      });
    }

    // now update logic if we are showing arrows for legend or not
    legendSvg.selectAll('.legendArrowLeftItem' + myClass)
      .attr('visibility', currentLegendItems.length === legendItems.length || legendIndexLeft === 0 ? "hidden" : "visible");
    legendSvg.selectAll('.legendArrowRightItem' + myClass)
      .attr('visibility', currentLegendItems.length === legendItems.length ? "hidden" : "visible");

    let rightArrowPos;
    if (useFixedLength) {
      const itemDisplayWidth = maxTextWidth + 35;
      rightArrowPos = 60 + (currentLegendItems.length * itemDisplayWidth);
    } else {
      rightArrowPos = 60 + shownLegendsWidth + 20;
    }


    // legend arrow circle left
    legendSvg.select('.legendArrowCircleLeft' + myClass)
      .attr('r', 10)
      .attr('fill', 'transparent')
      .attr('stroke', '#E8EAEE')
      .attr('cursor', 'pointer')
      .attr('cx', side === "left" ? 16 : (legendWidth - shownLegendsWidth - 15))
      .attr('cy', this.margins.legend - 20)
      .on('click', () => {
        console.log("LEFT");
        // on click, moves left and right behind one
        legendIndexLeft -= 1;
        legendIndexRight -= 1;
        // hard copy legend items
        const myFilteredLegendItems = JSON.parse(JSON.stringify(legendItems));
        // find new legend items using indices and draw legend
        currentLegendItems = myFilteredLegendItems.filter((f: any) => (f.index >= legendIndexLeft && f.index <= legendIndexRight));
        this.dotColors = legendItemsAndColors;

        // right always visible (if the legend fits this will never be visible so will not be able to be clicked
        legendSvg.selectAll('.legendArrowRightItem' + myClass).attr('visibility', 'visible');
        if (legendIndexLeft === 0) {
          // if left index is now 0, hide this circle so cannot click beyond range
          legendSvg.selectAll('.legendArrowLeftItem' + myClass).attr('visibility', 'hidden');
        }

        // re draw the svg depending on which side we want to update
        side === "left" ? this.drawLegend(currentLegendItems) : this.drawLegend(currentLegendItems, 'right');
      });

    // arrow, pointer event none
    legendSvg.select('.legendArrowLeft' + myClass)
      .attr('fill', '#1363DF')
      .attr('font-weight', 'bold')
      .attr('font-size', '16')
      .attr('text-anchor', 'middle')
      .attr('pointer-events', 'none')
      .attr('x', side === "left" ? 15 : (legendWidth - shownLegendsWidth - 15))
      .attr('y', this.margins.legend - 15)
      .text('<');

    // right hand circle
    legendSvg.select('.legendArrowCircleRight' + myClass)
      .attr('r', 10)
      .attr('fill', 'transparent')
      .attr('stroke', '#E8EAEE')
      .attr('cursor', 'pointer')
      .attr('cx', side === "left" ? rightArrowPos : legendWidth - 25)
      .attr('cy', this.margins.legend - 20)
      .on('click', () => {
        // move legend indices along one
        legendIndexLeft += 1;
        legendIndexRight += 1;
        // hard clone all legend items
        const myFilteredLegendItems = JSON.parse(JSON.stringify(legendItems));
        // filter to current selection and draw legend
        currentLegendItems = myFilteredLegendItems.filter((f: any) => (f.index >= legendIndexLeft && f.index <= legendIndexRight));
        this.dotColors = legendItemsAndColors;

        // left hand circle always visible (see above re: logic)
        legendSvg.selectAll('.legendArrowLeftItem' + myClass).attr('visibility', 'visible');
        if (legendIndexRight === (legendItems.length - 1)) {
          // if we have reached the last record, hide this circle so you cannot click out of range
          legendSvg.selectAll('.legendArrowRightItem' + myClass).attr('visibility', 'hidden');
        }

        // re draw the svg depending on which side we want to update
        side === "left" ? this.drawLegend(currentLegendItems) : this.drawLegend(currentLegendItems, 'right');
      });

    // arrow label, pointer events none
    legendSvg.select('.legendArrowRight' + myClass)
      .attr('fill', '#1363DF')
      .attr('font-weight', 'bold')
      .attr('font-size', '16')
      .attr('text-anchor', 'middle')
      .attr('pointer-events', 'none')
      .attr('x', side === "left" ? rightArrowPos : legendWidth - 25)
      .attr('y', this.margins.legend - 15)
      .text('>');



    return currentLegendItems;

    function measureWidth(myText: any, myFontSize: any): any {
      const context: any = document.createElement('canvas').getContext('2d');
      context.font = myFontSize + 'px Poppins, sans-serif';
      return context.measureText(myText).width;
    }
  }


  /**
  * Function to zoom into the lasso selection
  *
  * @param selectedPoints - data behind points being zoomed into
  * @param updateSelectedPointsData - update selectedPointsData. Needed when we are zoomed in
  * and want to apply a legend filter 
  */
  // FIXME:
  zoomIntoSelectedPoints(selectedPoints: dqm_scatter_data[], updateSelectedPointsData = true) {
    const myChart = this;
    const myClass = myChart.divId;
    const mySvg = d3.select('#svg_' + myClass);

    // Useful for when we are zoomed into some points and want to apply a filter.
    if (updateSelectedPointsData) {
      myChart.selectedPointsData = selectedPoints;
      myChart.displayData = myChart.selectedPointsData;
    }

    // Get the selected points inside the lasso
    // *MAYBE* TODO: use getPointsInsideLasso instead so we update our selectedPoints


    // Compute new x and y domains
    const xExtent: any = d3.extent(selectedPoints, (d: any) => d.source_nm);
    const yExtent: any = d3.extent(selectedPoints, (d: any) => d.y);

    // X values are the same so spread the range a bit
    if (xExtent[0] === xExtent[1]) {
      xExtent[0] = xExtent <= 100 ? 0 : xExtent[0] - 100;
      xExtent[1] += 100;
    }
    // Y values are the same so spread the range a bit
    if (yExtent[0] === yExtent[1]) {
      yExtent[0] = yExtent <= 100 ? 0 : yExtent[0] - 100;
      yExtent[1] += 100;
    }
    // Get unique source names from zoomed points and sort them by patient volume
    const zoomedSources = this.getSortedSourcesByVolume(selectedPoints);
    // myChart.sources = zoomedSources;

    // Update scales
    this.xScale.domain(zoomedSources).range([myChart.margins.left, myChart.width]);
    // subXScale.range([0, xScale.bandwidth()]); // Fit within each new `source_nm` band which should now be bigger
    // Update domain to focus on the selected sources
    this.yScale.domain([yExtent[0], yExtent[1]]).nice();

    // Transition axes WITHOUT transition for checkWidth to measure accurately
    mySvg.select(".xAxis" + myClass)
      .call(myChart.xAxis)
      .call((g: any) => {
        g.selectAll(".tick text")
          .attr("dy", "1.5em") // Add padding below ticks
          .attr("color", "#000000")
          .attr("font-weight", "bold")
          .attr("font-family", "Poppins")
        g.select(".domain")
          .attr("stroke", myChart.gray); // set color 
      });

    // check to see if we need to update the width
    let widthUpdated = myChart.checkWidth();
    // if we updated the width reupdate the chart
    if (widthUpdated) {
      this.zoomIntoSelectedPoints(selectedPoints);
      return;
    }

    // Update gradient bar colors based on new scale
    d3.selectAll(".y-gradient-step")
      .each(function (d: any, i: number) {
        const stepHeight = parseFloat(d3.select(this).attr("height"));
        const yPos = parseFloat(d3.select(this).attr("y"));
        const midYVal = myChart.yScale.invert(yPos + stepHeight / 2);
        const newColor = myChart.getStepColor(midYVal);
        d3.select(this).attr("fill", newColor);
      });


    // gridlines next to each source
    mySvg.selectAll(".x-gridline")
      .data(zoomedSources)
      .join("line")
      .transition()
      .duration(750)
      .attr("class", "x-gridline")
      .attr("x1", (d: any) => (myChart.xScale(d) ?? 0) + myChart.xScale.bandwidth()) // RIGHT edge
      .attr("x2", (d: any) => (myChart.xScale(d) ?? 0) + myChart.xScale.bandwidth()) // RIGHT edge
      .attr("y1", myChart.margins.top)
      .attr("y2", myChart.props.chartHeight - myChart.margins.bottom)
      .attr("stroke", myChart.gray)
      .attr("stroke-width", 1)
      .attr("stroke-dasharray", "10 8");

    // Y axis
    mySvg.select(".yAxis" + myClass)
      .transition()
      .duration(750)
      .attr("transform", `translate(${myChart.margins.left},0)`)
      .call(myChart.yAxis)

    // Remove the words Spike, and ip on zoom in
    mySvg.selectAll(".yAxis" + myClass + "-label")
      .style('visibility', 'hidden');


    // Define the visible boundaries of your chart
    const chartTop = myChart.margins.top;
    const chartBottom = myChart.props.chartHeight - myChart.margins.bottom;
    const yZeroPos = myChart.yScale(0);

    // Calculate the clamped Y position.
    // This value will be yZeroPos, but never higher than chartTop or lower than chartBottom.
    const clampedY = Math.max(chartTop, Math.min(yZeroPos, chartBottom));

    // Line that goes across at y = 0
    mySvg.select(".zeroLine")
      .transition()
      .duration(750)
      .attr("x1", myChart.margins.left)
      .attr("x2", myChart.width)
      .attr("y1", clampedY) // Use clamped position
      .attr("y2", clampedY) // Use clamped position
      .attr("stroke", myChart.gray)
      .attr("stroke-width", 1);


    const isVisible = yZeroPos >= chartTop && yZeroPos <= chartBottom;
    // The word "mean" that sticks to the line
    mySvg.select(".zeroLineLabel")
      .transition()
      .duration(750)
      .style("opacity", isVisible ? 1 : 0) // Control visibility
      .attr("x", myChart.margins.left - 30)
      .attr("y", clampedY + 30)
      .attr("transform", `rotate(-90, ${myChart.margins.left - 30}, ${clampedY + 30})`);


    // Y is either the position of y=0 or the top of the chart, whichever is lower (larger value).
    const boxY = Math.max(yZeroPos, chartTop);

    // Determine the correct height.
    // It's the distance from the calculated top (boxY) to the chart bottom.
    // Use Math.max(0, ...) to prevent negative height if the box is entirely off-screen.
    const boxHeight = Math.max(0, chartBottom - boxY);

    mySvg.select(".zeroBox")
      .transition()
      .duration(750)
      .attr("x", myChart.margins.left)
      .attr("y", boxY)
      .attr("width", myChart.width - myChart.margins.left)
      .attr("height", boxHeight)
      .attr("fill", myChart.gray)
      .attr("opacity", 0.25);


    // update the postion of our points and bands based on our selectedPoints
    this.renderPointsandBackgroundBands(selectedPoints);

    // Clear the lasso selection
    mySvg.select(".lasso-layer").selectAll("path").remove();

    // Reset the colors of the points back to normal
    d3.selectAll(".data_point").attr("style", null);
    this.current_theme == "anomaly" ? this.setAnomalyThemeColors() : this.setKPIThemeColors();
  }
  resetZoom(shouldCheckWidth: boolean = false) {
    const myChart = this;
    const myClass = myChart.divId;
    const mySvg = d3.select('#svg_' + myClass);

    myChart.isZoomedToSelection = false;
    this.selectedPointsData = [];
    // check if we still have any legendFilters active
    this.updateDataViaLegendFilter(this.current_theme);

    // Update scales
    myChart.xScale
      .domain(this.getSortedSourcesByVolume(this.displayData))
      .range([myChart.margins.left, myChart.width]);

    myChart.subXScale
      .domain(myChart.selectedCategories) // Reset domain to all subcategories
      .range([0, myChart.xScale.bandwidth()]);
    myChart.subXScaleMap.clear();

    myChart.yScale.domain([myChart.yMin, myChart.yMax]).nice().range([myChart.props.chartHeight - myChart.margins.bottom, myChart.margins.top]);

    const lassoLayer = mySvg.select(".lasso-layer");
    // Transition axes
    mySvg.select(".grid.x-axis").transition().duration(750).call(myChart.xAxis);
    mySvg.select(".grid.y-axis").transition().duration(750).call(myChart.yAxis);

    // check if we need to redraw the chart because source labels do not fit
    if (shouldCheckWidth) {
      // Want to redraw so do not have a transition 
      mySvg.select(".xAxis" + myClass)
        .call(myChart.xAxis)
        .call((g: any) => {
          g.selectAll(".tick text")
            .attr("dy", "1.5em") // Add padding below ticks
            .attr("color", "#111111ff")
            .attr("font-weight", "bold")
          // .attr("stroke-width", "1px")
          g.select(".domain")
            .attr("stroke", myChart.gray); // set color 
        });
      let redraw = myChart.checkWidth();
      // reset zoom but now it will have a transition
      myChart.resetZoom();
      // if (checkWidth())  resetZoom(); // Recall to rebuild now that width has changed
    }
    else {
      // Transition axes
      mySvg.select(".xAxis" + myClass)
        .transition()
        .duration(750)
        .call(myChart.xAxis)
        .call((g: any) => {
          g.selectAll(".tick text")
            .attr("dy", "1.5em") // Add padding below ticks
            .attr("color", "#111111ff")
            .attr("font-weight", "bold")
          // .attr("stroke-width", "1px")
          g.select(".domain")
            .attr("stroke", myChart.gray); // set color 
        });
    }

    // render the points and background bands onto the chart
    myChart.renderPointsandBackgroundBands(this.displayData);

    // Clear the lasso 
    lassoLayer.selectAll("path").remove();

    // Line that goes across at y = 0 
    mySvg.select(".zeroLine")
      .transition()
      .duration(750)
      .attr("x1", myChart.margins.left)
      .attr("x2", myChart.width)
      .attr("y1", myChart.yScale(0))
      .attr("y2", myChart.yScale(0))
      .attr("stroke", myChart.gray)
      .attr("stroke-width", 1);

    // The word mean that stick to the line going across at y=0
    mySvg.select(".zeroLineLabel")
      .transition()
      .duration(750)
      .style("opacity", 1)
      .attr("x", myChart.margins.left - 30) // adjust as needed
      .attr("y", myChart.yScale(0) + 10)
      .attr("transform", `rotate(-90, ${myChart.margins.left - 30}, ${myChart.yScale(0) + 10})`) // rotate around the label’s x,y

    const yZeroPos = myChart.yScale(0);
    // Define the visible boundaries of your chart
    const chartTop = myChart.margins.top;
    const chartBottom = myChart.props.chartHeight - myChart.margins.bottom;
    // Y is either the position of y=0 or the top of the chart, whichever is lower (larger value).
    const boxY = Math.max(yZeroPos, chartTop);

    // Determine the correct height.
    // It's the distance from the calculated top (boxY) to the chart bottom.
    // Use Math.max(0, ...) to prevent negative height if the box is entirely off-screen.
    const boxHeight = Math.max(0, chartBottom - boxY);

    mySvg.select(".zeroBox")
      .transition()
      .duration(750)
      .attr("x", myChart.margins.left)
      .attr("y", boxY)
      .attr("width", myChart.width - myChart.margins.left)
      .attr("height", boxHeight)
      .attr("fill", myChart.gray)
      .attr("opacity", 0.25)

    // gridlines next to each source
    mySvg.selectAll(".x-gridline")
      .data(myChart.sources)
      .join("line")
      .transition()
      .duration(750)
      .attr("class", "x-gridline")
      .attr("x1", (d: any) => (myChart.xScale(d) ?? 0) + myChart.xScale.bandwidth()) // RIGHT edge
      .attr("x2", (d: any) => (myChart.xScale(d) ?? 0) + myChart.xScale.bandwidth()) // RIGHT edge
      .attr("y1", myChart.margins.top)
      .attr("y2", myChart.props.chartHeight - myChart.margins.bottom)
      .attr("stroke", myChart.gray)
      .attr("stroke-width", 1)
      .attr("stroke-dasharray", "10 8");

    // Gradient bar next to yAxis
    // Update gradient bar colors based on new scale
    d3.selectAll(".y-gradient-step")
      .each(function (d: any, i: number) {
        const stepHeight = parseFloat(d3.select(this).attr("height"));
        const yPos = parseFloat(d3.select(this).attr("y"));
        const midYVal = myChart.yScale.invert(yPos + stepHeight / 2);
        const newColor = myChart.getStepColor(midYVal);
        d3.select(this)
          .transition()
          .duration(750)
          .attr("fill", newColor);
      });

    // Y axis
    mySvg.select(".yAxis" + myClass)
      .transition()
      .duration(750)
      .attr("transform", `translate(${myChart.margins.left},0)`)
      .call(myChart.yAxis)
    // Change color of Axis

    // Make sure spike and dip are visible again
    // mySvg.selectAll(".yAxis" + myClass + "-label")
    //   .style('visibility', 'visible');
    mySvg.select(".dip-label")
      .style('visibility', this.masterData.some(item => item.y < this.lowerBound) ? 'visible' : 'hidden');

    mySvg.select(".spike-label")
      .style('visibility', this.masterData.some(item => item.y > this.upperBound) ? 'visible' : 'hidden');

  }

  // Function to see if we need to increase the width of our chart
  checkWidth(): boolean {
    const myChart = this;
    const myClass = myChart.divId;
    const mySvg = d3.select('#svg_' + myClass);
    const tickTexts = mySvg.selectAll(".xAxis" + myClass + " .tick text").nodes();
    const maxLabelWidth = Math.max(...tickTexts.map(n => (n as SVGTextElement).getBBox().width));

    const domainSize = this.xScale.domain().length;
    const bandWidth = this.xScale.bandwidth();
    const totalLabelWidth = maxLabelWidth * domainSize;

    const minSafeWidth = totalLabelWidth + myChart.margins.left + myChart.margins.right;

    // if bands are too small for text
    if (maxLabelWidth > bandWidth) {
      // extend the length of the svg
      myChart.width = minSafeWidth;
      mySvg.attr("width", myChart.width);
      return true;
    } else {
      // Only shrink if current width is larger than needed AND labels still fit
      if (myChart.width > minSafeWidth) {
        if (myChart.width === myChart.cardWidthWithoutScrolling) return false;
        myChart.width = Math.max(myChart.cardWidthWithoutScrolling, minSafeWidth);
        mySvg.attr("width", myChart.width);
        return true;
      }
      return false;
    }
  }

  /**
   * Updates the domains of X, Y, and sub-X scales based on the provided data.
   * This is crucial for zooming and filtering.
   * @param dataForExtent - The array of ScatterDataPoint to calculate extents from.
   * If empty, scales revert to initial/default domains.
   */
  updateScalesAndDomains() {
    const myChart = this;

    if (this.displayData.length === 0) {
      this.noData = true;
      return;
    }
    else {
      this.noData = false;
    }

    // Compute new x and y domains
    const xExtent: any = d3.extent(this.displayData, (d: any) => d.source_nm);
    const yExtent: any = d3.extent(this.displayData, (d: any) => d.y);

    // X values are the same so spread the range a bit
    if (xExtent[0] === xExtent[1]) {
      xExtent[0] = xExtent <= 100 ? 0 : xExtent[0] - 100;
      xExtent[1] += 100;
    }
    // Y values are the same so spread the range a bit
    if (yExtent[0] === yExtent[1]) {
      yExtent[0] = yExtent <= 100 ? 0 : yExtent[0] - 100;
      yExtent[1] += 100;
    }
    // Get unique source names from zoomed points and sort them by patient volume
    const zoomedSources = this.getSortedSourcesByVolume(this.displayData);

    // Update scales
    this.xScale.domain(zoomedSources).range([myChart.margins.left, myChart.width]);
    // subXScale.range([0, xScale.bandwidth()]); // Fit within each new `source_nm` band which should now be bigger
    // Update domain to focus on the selected sources
    this.yScale.domain([yExtent[0], yExtent[1]]).nice();
  }

  // Will render points normally on initial plot, but will render points with d3 force if we are zooming in
  renderPointsandBackgroundBands(data: dqm_scatter_data[]): any {
    const myChart = this;
    const myClass = myChart.divId;
    const mySvg = d3.select('#svg_' + myClass);
    const pointRadius = 6; // Define this once for reuse

    const sources = this.getSortedSourcesByVolume(data);
    myChart.sources = sources;

    // render background bands first to set subXScaleMap
    if (this.selectedCategories.length != 0) {
      // remove previous bands if they exist
      mySvg.selectAll(".background_band_group").remove();
      // Append Background Bands (Rectangles) for each subcategory within each source_nm
      mySvg.selectAll(".background_band")
        .data(sources) // Loop over each source_nm
        .enter()
        .append("g") // Group the rectangles by source
        .attr("class", "background_band_group")
        .lower()
        .each(function (this: SVGGElement, source: any) {
          // For each source, append rectangles for all subcategories
          d3.select(this)
            .selectAll("rect")
            .data(myChart.selectedCategories) // Loop over each subcategory for that source_nm
            .enter()
            .append("rect")
            .attr("class", "background_band")
            .attr("x", (subcategory: any) => {
              return (myChart.xScale(source) ?? 0) + (myChart.subXScale(subcategory) ?? 0)
            }) // Correct x positioning within source for subcategory
            .attr("y", myChart.margins.top)
            .attr("width", myChart.subXScale.bandwidth()) // Width based on subcategory band
            .attr("height", myChart.props.chartHeight - myChart.margins.top - myChart.margins.bottom) // Height of the entire band
            .attr("fill", (subcategory: any) => myChart.colorScale(subcategory) as string) // Color based on subcategory
            .attr("opacity", 0.1); // Semi-transparent background
          // Inside the .each() function where `source` is already available
          const selectedSubcategories = data
            .filter((d: any) => d.x_axis_value === source)
            .map((d: any) => d.category ?? 'unknown');
          const uniqueSelectedSubcategories: any = Array.from(new Set(selectedSubcategories)).sort();
          const zoomedSources = myChart.getSortedSourcesByVolume(data);
          // Map for keeping track of which subcategory has been selected
          const scale = d3.scaleBand()
            .domain(uniqueSelectedSubcategories)
            .range([0, myChart.xScale.bandwidth()]);

          myChart.subXScaleMap.set(source, scale);

          // update the subXScale domain to now only use selected subcategories
          myChart.subXScale.domain(uniqueSelectedSubcategories)
            .range([0, myChart.xScale.bandwidth()]); // Adjust range to fit selected subcategories within the new source bandwidth

          const group = d3.select(this);
          group.selectAll(".background_band")
            .data(uniqueSelectedSubcategories)
            .join("rect") // Use join to update/enter/exit rects
            .attr("class", "background_band")
            .attr("x", (subcategory: any) => {
              // if our source is in zoomedSources then move it appropriately. If not then move it to the side
              if (zoomedSources.includes(source)) {
                return (myChart.xScale(source) ?? 0) + (myChart.subXScale(subcategory) ?? 0)
              }
              else {
                return d3.select(this).attr("x");
              }
            })
            .attr("width", myChart.subXScale.bandwidth())
            .attr("y", myChart.margins.top)
            .attr("height", myChart.props.chartHeight - myChart.margins.top - myChart.margins.bottom)
            .attr("fill", (subcategory: any) => myChart.colorScale(subcategory) as string)
            .attr("opacity", 0);
          // do not animate the position change, but animate the bands fading in
          group.selectAll(".background_band")
            .transition()
            .duration(750)
            .attr("opacity", zoomedSources.includes(source) ? 0.1 : 0);
        });
    }

    // --- START: CONDITIONAL POINT POSITIONING LOGIC ---
    const zoomScaleFactor = this.isZoomedToSelection ? 1.2 : 1;
    const smallRadius = 6;
    const textPadding = 1;

    const baseLabelFontSize = myChart.props.LabelfontSize || 10;

    const baseValueFontSize = myChart.props.circeValveFontSize || 10;
    const effectiveFontSize = this.isZoomedToSelection ? baseValueFontSize * zoomScaleFactor : baseValueFontSize;

    // --- STEP 1: CALCULATE A SINGLE UNIFORM LARGE RADIUS ---
    const tempSvgForMeasuring = mySvg.append("g").attr("opacity", 0);
    const allRequiredRadii = data.map((d: any) => {
      const textElement = tempSvgForMeasuring.append("text")
        .style("font-size", `${effectiveFontSize}px`)
        .text(d.kpi_value);
      const bbox = (textElement.node() as SVGTextElement).getBBox();
      const diagonal = Math.sqrt(Math.pow(bbox.width, 2) + Math.pow(bbox.height, 2));
      return (diagonal / 2) + textPadding;
    });
    tempSvgForMeasuring.remove();

    const largeRadius = Math.max(...allRequiredRadii, smallRadius);

    // Create effective radii based on zoom state
    const effectiveLargeRadius = this.isZoomedToSelection ? largeRadius * zoomScaleFactor : largeRadius;
    const effectiveSmallRadius = this.isZoomedToSelection ? smallRadius * zoomScaleFactor : smallRadius;

    let processedData: (dqm_scatter_data & { simx: number, simy: number, canGrow: boolean })[];

    const getTargetCoords = (d: dqm_scatter_data) => {
      // ... your getTargetCoords function remains the same
      const baseX = myChart.xScale(d.x_axis_value);
      let finalX = -1000;
      if (baseX !== undefined) {
        if (myChart.selectedCategories && myChart.selectedCategories.length !== 0) {
          const subScale = myChart.subXScaleMap.get(d.x_axis_value);
          if (subScale) {
            const subX = subScale(d.category ?? 'unknown');
            if (subX !== undefined) {
              finalX = baseX + subX + subScale.bandwidth() / 2;
            } else {
              finalX = baseX + myChart.xScale.bandwidth() / 2;
            }
          } else {
            finalX = baseX + myChart.xScale.bandwidth() / 2;
          }
        } else {
          finalX = baseX + myChart.xScale.bandwidth() / 2;
        }
      }
      return { x: finalX, y: myChart.yScale(d.y) };
    };
    if (this.useForce) {
      if (this.isZoomedToSelection || this.placePointsWithForce) {
        const increaseCollisionRadius = this.isZoomedToSelection ? 1.5 : 1.25;
        const collisionStrength = this.isZoomedToSelection ? 1.5 : 1.3;
        const placementForceY = this.isZoomedToSelection ? 0.7 : 1.0;
        const placementForceX = this.isZoomedToSelection ? 0.7 : 0.5;

        // We need to add fx and fy for the pinning logic.
        const simulationNodes = data.map(d => ({
          originalData: d,
          targetX: getTargetCoords(d).x,
          targetY: getTargetCoords(d).y,
          x: getTargetCoords(d).x,
          y: getTargetCoords(d).y,
          vx: 0,
          vy: 0,
          fx: null as number | null, // `fx` and `fy` are used to "pin" nodes
          fy: null as number | null,
        }));

        if (simulationNodes.length > 0) {
          // === PASS 1: SEPARATE & CLAMP ===

          // 1. Run the initial simulation to space out all points.
          const simulation = d3.forceSimulation(simulationNodes)
            .force("x", d3.forceX((d: any) => d.targetX).strength(placementForceX))
            .force("y", d3.forceY((d: any) => d.targetY).strength(placementForceY))
            .force("collide", d3.forceCollide(effectiveLargeRadius * increaseCollisionRadius).strength(collisionStrength).iterations(2));

          simulation.stop();
          for (let i = 0; i < 200; ++i) {
            simulation.tick();
          }

          // 2. Define boundaries and clamp points, IDENTIFYING which ones were moved.
          const topLimit = myChart.margins.top + effectiveLargeRadius;
          const bottomLimit = myChart.props.chartHeight - myChart.margins.bottom - effectiveLargeRadius;
          const leftLimit = myChart.margins.left + effectiveLargeRadius;
          const rightLimit = myChart.width - myChart.margins.right - effectiveLargeRadius;

          simulationNodes.forEach(node => {
            const preClampX = node.x;
            const preClampY = node.y;

            // Apply the clamp
            node.x = Math.max(leftLimit, Math.min(rightLimit, node.x));
            node.y = Math.max(topLimit, Math.min(bottomLimit, node.y));

            // If the clamp moved the node, "pin" it by setting its fixed position (fx, fy).
            if (node.x !== preClampX || node.y !== preClampY) {
              node.fx = node.x;
              node.fy = node.y;
            }
          });

          // === PASS 2: RELAXATION ===

          // 3. "Reheat" the simulation by resetting the alpha target.
          simulation.alphaTarget(0.3).restart();

          // 4. Run for a few more steps. The "free" nodes will now be pushed away from the "pinned" nodes.
          for (let i = 0; i < 150; ++i) {
            simulation.tick();
          }
          simulation.stop();

          // 5. (Optional but recommended) Un-pin all nodes for the next render.
          simulationNodes.forEach(node => {
            node.fx = null;
            node.fy = null;
          });
        }
        processedData = simulationNodes.map(node => ({
          ...node.originalData,
          simx: node.x,
          simy: node.y,
          canGrow: false,
        }));
      } else {
        const jitter = (value: number) => value * (Math.random() - 0.5);
        processedData = data.map(d => ({
          ...d,
          simx: getTargetCoords(d).x + jitter(18),
          simy: getTargetCoords(d).y + jitter(18),
          canGrow: false,
        }));
      }
    }
    else {
      const jitter = (value: number) => value * (Math.random() - 0.5);
      processedData = data.map(d => ({
        ...d,
        simx: getTargetCoords(d).x + jitter(18),
        simy: getTargetCoords(d).y + jitter(18),
        canGrow: false,
      }));
    }

    // --- STEP 3: UNIVERSAL `canGrow` and CLAMPING STAGE ---

    // This stage now clamps points to BOTH the chart edges and their specific data bands.
    const clampedData = processedData.map(node => {
      // We use effectiveLargeRadius for all clamping calculations to be safe.
      const clampRadius = effectiveLargeRadius;

      // --- 1. Get the Overall Chart Boundaries ---
      const chartLeft = myChart.margins.left + clampRadius;
      const chartRight = myChart.width - myChart.margins.right - clampRadius;
      const chartTop = myChart.margins.top + clampRadius;
      const chartBottom = myChart.props.chartHeight - myChart.margins.bottom - clampRadius;

      let finalLeftLimit = chartLeft;
      let finalRightLimit = chartRight;

      // --- THE FIX: Only apply the tight band-clamping in force/zoom mode ---
      if (this.isZoomedToSelection || this.placePointsWithForce) {
        const subScale = myChart.subXScaleMap.get(node.x_axis_value);
        if (subScale) {
          const sourceX = myChart.xScale(node.x_axis_value) ?? 0;
          const subX = subScale(node.category ?? 'unknown') ?? 0;
          const bandLeft = sourceX + subX + clampRadius;
          const bandRight = sourceX + subX + subScale.bandwidth() - clampRadius;

          // Combine chart and band boundaries to find the most restrictive space
          finalLeftLimit = Math.max(chartLeft, bandLeft);
          finalRightLimit = Math.min(chartRight, bandRight);
        }
      }

      // Clamp the coordinates using the final boundaries
      const clampedX = Math.max(finalLeftLimit, Math.min(finalRightLimit, node.simx));
      const clampedY = Math.max(chartTop, Math.min(chartBottom, node.simy));

      return { ...node, simx: clampedX, simy: clampedY };
    });

    // Now, with the FINAL clamped positions, we can accurately check for collisions.
    const finalData = clampedData.map(d1 => {
      let canGrow = true;
      for (const d2 of clampedData) {
        if (d1.id === d2.id) continue;
        const distance = Math.sqrt(Math.pow(d1.simx - d2.simx, 2) + Math.pow(d1.simy - d2.simy, 2));
        if (distance < effectiveLargeRadius * 2 || !this.useForce) {
          canGrow = false;
          break;
        }
      }
      return { ...d1, canGrow };
    });

    const finalNodeMap = new Map(finalData.map(node => [node.id, node]));

    // --- STEP 4: UNIVERSAL RENDERING LOGIC ---

    const dotGroup = mySvg.select("#dotGroup");
    const pointGroups = dotGroup.selectAll<SVGGElement, any>(".point-group")
      .data(finalData, (d: any) => d.id);

    pointGroups.exit().transition().duration(750).style("opacity", 0).remove();

    const enterGroups = pointGroups.enter().append("g")
      .attr("class", "point-group")
      .style("opacity", 0)
      .attr("transform", (d: any) => `translate(${d.simx}, ${d.simy})`);

    // Append the circle to the group
    // Note: cx and cy are now 0 because the group is translated
    enterGroups.append("circle")
      .attr("r", effectiveSmallRadius) // Start with radius 0 for the transition
      .attr("class", "data_point")
      .attr("fill", (d: any) => this.getPointColor(d)) // Set initial fill color
      .attr("stroke", (d: any) => this.getPointColor(d)) // Set initial stroke color
      .attr("fill-opacity", (d: any) => this.getPointOpacity(d)) // Set initial opacity
      // All your event handlers are moved here
      .on("mouseover", (event: any, d: any) => this.showTooltip(d, event.offsetX, event.offsetY, this.width, myChart.props.chartHeight))
      .on("mousemove", (event: any, d: any) => this.showTooltip(d, event.offsetX, event.offsetY, this.width, myChart.props.chartHeight))
      .on("mouseout", () => this.hideTooltip())
      .on("click", (event: any, d: any) => {
        this.showMouseButtons(event, true);
        if (!event.shiftKey) this.selectedPoints = [];
        this.selectedPoints.push(event.srcElement);
        myChart.compareClick("route");
      });
    enterGroups.append("text")
      .attr("class", "kpi-value-text")
      .attr("visibility", myChart.props.circeValveShow ? 'visible' : 'hidden')
      .attr("font-weight", myChart.props.circeValveBold ? "bold" : "normal")
      .style("pointer-events", "none")
      .attr("text-anchor", "middle")
      .attr("dy", "0.35em")
       .style("font-size", `${myChart.props.circeValveFontSize}px`)
      .style("fill", (d: any) => {
        const color = this.getPointColor(d);
        const opacity = this.getPointOpacity(d);
        const effectiveColor = this.getEffectiveColor(color, opacity);
        return (myChart.props.circeValveColor || this.getContrastColor(effectiveColor));
      }) // Set initial text color
      .style("opacity", 0)
      .text((d: any) => d.kpi_value);

    const mergedGroups = enterGroups.merge(pointGroups);

    mergedGroups.transition().duration(750)
      .attr("transform", (d: any) => `translate(${d.simx}, ${d.simy})`)
      .style("opacity", 1);

    // --- FIX #2: Use EFFECTIVE radii for final rendering ---
    mergedGroups.select("circle")
      .transition().duration(750)
      .attr("r", (d: any) => d.canGrow ? effectiveLargeRadius : effectiveSmallRadius);

    mergedGroups.select("text")
      .transition().duration(750)
      .style("font-size", `${effectiveFontSize}px`)
      .style("opacity", (d: any) => d.canGrow ? 1 : 0);

    // --- RENDER LABELS ---

    const labelTextHeight = 10;
    const labelVerticalMarginTotal = 10;
    const horizontalLabelPaddingForCollision = 2; // Increased slightly for the box
    const placedLabelBoundingBoxes: { x: number, y: number, width: number, height: number, id: string }[] = [];
    const labelTargetsMap = new Map<string | number, {
      opacity: number,
      groupTransform: string,
      indicatorPath: string,
      textAlign: string,
      lines: string[], // Store the split lines
      boxWidth: number, // Store the calculated box dimensions
      boxHeight: number,
      boxX: number,
      boxY: number
    }>();

    const labelGroups = mySvg.selectAll<SVGGElement, any>(".point-label-group")
      .data(data, (d: any) => `label-group-${d.id}`);

    labelGroups.exit().transition("labelExit").duration(300).style("opacity", 0).remove();
    const enterLabelGroups = labelGroups.enter().append("g")
      .attr("class", "point-label-group")
      .style("pointer-events", "none");
    // if (myChart.props.Labelbackground) {
    // 1. Append the background rect FIRST so it's behind the text
    enterLabelGroups.append("rect")
      .attr("class", "point-label-bg")
      .attr("fill", (myChart.props.LabelbackgroundColor || "white"))
      .attr("stroke", "#4d4d4dff") // Optional: add a subtle border
      .attr("stroke-width", 0.5)
      .attr("rx", 2) // Rounded corners
      .attr("ry", 2);
    // }
    // 2. Append the text element
    enterLabelGroups.append("text")
      .attr("class", "point-source-label-text")
      .style("font-size", `${myChart.props.LabelfontSize}px`)
      .style("fill", (myChart.props.Labelcolor || "#333"));
    // .attr("dy", "0.35em"); // We'll handle dy manually for multi-line

    // 3. Append the indicator path
    enterLabelGroups.append("path")
      .attr("class", "point-label-indicator")
      .style("stroke", "#666").style("stroke-width", 1).style("fill", "none");

    const mergedLabelGroupsForLabels = enterLabelGroups.merge(labelGroups);
    // Ensure accurate measurement by applying the font size immediately
    mergedLabelGroupsForLabels.select(".point-source-label-text")
      .style("font-size", `${myChart.props.LabelfontSize}px`);

    // Helper to split text
    const splitText = (text: string, maxChars: number): string[] => {
      const words = text.split(/\s+/);
      const lines: string[] = [];
      let currentLine = words[0];

      for (let i = 1; i < words.length; i++) {
        if (currentLine.length + 1 + words[i].length <= maxChars) {
          currentLine += " " + words[i];
        } else {
          lines.push(currentLine);
          currentLine = words[i];
        }
      }
      lines.push(currentLine);
      return lines;
    };

    mergedLabelGroupsForLabels.each(function (d1: any) {
      const finalNode1 = finalNodeMap.get(d1.id);
      if (!finalNode1) { /* ... */ return; }

      const currentPointRadius = finalNode1.canGrow ? effectiveLargeRadius : effectiveSmallRadius;
      const labelIndicatorMarginFromText = currentPointRadius * .25;
      const p1_cx = finalNode1.simx;
      const p1_cy = finalNode1.simy;

      // --- PREPARE TEXT ---
      // Split the text into lines
      const maxCharsPerLine = 15; // Adjust as needed
      const lines = splitText(d1.kpi_name, maxCharsPerLine);

      // Measure dimensions
      const lineHeight = baseLabelFontSize * 1.2; // Approximate line height
      const totalTextHeight = lines.length * lineHeight;

      // We need to measure the width of the widest line.
      // We can use a temporary text element or estimate. 
      // Since we are in a loop, let's use the existing text element to measure.
      const textElement = d3.select(this).select<SVGTextElement>(".point-source-label-text");

      // Temporarily set text to find max width
      let maxLineWidth = 0;
      lines.forEach(line => {
        textElement.text(line);
        const w = textElement.node()!.getBBox().width;
        if (w > maxLineWidth) maxLineWidth = w;
      });
      // Clear text for now, we will set tspan later
      textElement.text("");

      const boxPadding = 4;
      const boxWidth = maxLineWidth + (boxPadding * 2);
      const boxHeight = totalTextHeight + (boxPadding * 2);

      const distance = currentPointRadius + labelVerticalMarginTotal + 1;
      const positions = [
        { angle: -Math.PI / 2, align: 'middle' },
        { angle: Math.PI / 2, align: 'middle' },
        { angle: -Math.PI / 4, align: 'start' },
        { angle: Math.PI / 4, align: 'start' },
        { angle: -Math.PI * 3 / 4, align: 'end' },
        { angle: Math.PI * 3 / 4, align: 'end' },
        { angle: 0, align: 'start' },
        { angle: Math.PI, align: 'end' },
      ];
      const plotAreaTop = myChart.margins.top;
      const plotAreaBottom = myChart.props.chartHeight - myChart.margins.bottom;
      const plotAreaLeft = myChart.margins.left;
      const plotAreaRight = myChart.width - myChart.margins.right;

      let calculatedTargets = {
        opacity: 0,
        groupTransform: `translate(${p1_cx}, ${p1_cy})`,
        indicatorPath: 'M0,0',
        textAlign: 'middle',
        lines: lines,
        boxWidth: boxWidth,
        boxHeight: boxHeight,
        boxX: 0,
        boxY: 0
      };

      for (const pos of positions) {
        // Increase distance for top/bottom (middle alignment)
        const extraDistance = pos.align === 'middle' ? 15 : 0;
        const effectiveDistance = distance + extraDistance;

        const groupX = p1_cx + Math.cos(pos.angle) * effectiveDistance;
        const groupY = p1_cy + Math.sin(pos.angle) * effectiveDistance;

        // Calculate where the BOX should be relative to groupX/Y
        // groupX/Y is the anchor point for the text block.

        let boxXOffset = 0;
        if (pos.align === 'middle') boxXOffset = -boxWidth / 2;
        else if (pos.align === 'start') boxXOffset = 0;
        else boxXOffset = -boxWidth;

        // Center the box vertically around groupY is usually good,
        // OR place it so groupY is the top/bottom/center.
        // Let's assume groupY is the vertical center of the box for simplicity in radial layout
        const boxYOffset = -boxHeight / 2;

        const candidateRect: any = {
          x: groupX + boxXOffset,
          y: groupY + boxYOffset,
          width: boxWidth,
          height: boxHeight
        };

        // Check boundaries
        if (candidateRect.y < plotAreaTop || (candidateRect.y + candidateRect.height) > plotAreaBottom ||
          candidateRect.x < plotAreaLeft || (candidateRect.x + candidateRect.width) > plotAreaRight) {
          continue;
        }

        if (checkCollision(candidateRect)) {
          const relativeStartX = p1_cx - groupX;
          const relativeStartY = p1_cy - groupY;
          const centerToCenterLength = Math.sqrt(relativeStartX * relativeStartX + relativeStartY * relativeStartY);

          // Start at the edge of the point
          const startAtEdgeX = relativeStartX - (currentPointRadius * (relativeStartX / centerToCenterLength));
          const startAtEdgeY = relativeStartY - (currentPointRadius * (relativeStartY / centerToCenterLength));

          // End at the edge of the BOX
          // We need to find the intersection of the line segment (relativeStartX, relativeStartY) -> (0,0)
          // with the box rectangle defined by (boxXOffset, boxYOffset, boxWidth, boxHeight).
          // Since (0,0) is the anchor, and for:
          // - Middle: (0,0) is center of box.
          // - Start: (0,0) is left-center of box.
          // - End: (0,0) is right-center of box.

          let endAtGapX = 0;
          let endAtGapY = 0;

          if (pos.align === 'middle') {
            // Anchor is center. Line comes from top or bottom.
            // If relativeStartY < 0 (point is above), line hits top edge (y = boxYOffset)
            // If relativeStartY > 0 (point is below), line hits bottom edge (y = boxYOffset + boxHeight)
            // We can just clamp the line to the box bounds.
            // Actually, simpler: just stop at boxYOffset or boxYOffset + boxHeight.
            // But we need to handle the X component too if it's not perfectly vertical (though it should be for PI/2).
            // Let's do a proper intersection or just use the known geometry.

            // Since angle is PI/2 or -PI/2, X is 0.
            if (pos.angle === -Math.PI / 2) { // Top
              // Point is below label? No, -PI/2 is UP. Point is below label?
              // p1_y + sin(-90)*d = p1_y - d. Label is ABOVE point.
              // Point is at p1_y. Label is at p1_y - d.
              // relativeStartY = p1_y - (p1_y - d) = d > 0.
              // Wait, relativeStartY = p1_cy - groupY.
              // If label is above, groupY < p1_cy. relativeStartY is POSITIVE.
              // Line comes from POSITIVE Y (bottom) to 0 (center).
              // It hits the BOTTOM of the box.
              endAtGapY = boxYOffset + boxHeight;
            } else { // Bottom (PI/2)
              // Label is below point. groupY > p1_cy. relativeStartY is NEGATIVE.
              // Line comes from NEGATIVE Y (top) to 0 (center).
              // It hits the TOP of the box.
              endAtGapY = boxYOffset;
            }
            endAtGapX = 0; // Vertical
          } else {
            // For Start/End, the anchor (0,0) is on the vertical edge of the box.
            // Start: Anchor is Left-Center. Point is to Left. Line hits Left Edge. (0,0) is fine.
            // End: Anchor is Right-Center. Point is to Right. Line hits Right Edge. (0,0) is fine.
            // We might want to nudge it slightly if there's a border or padding?
            // Let's leave it at 0,0 for now as it connects to the "box" edge effectively.
            endAtGapX = 0;
            endAtGapY = 0;
          }

          const indicatorPath = `M ${startAtEdgeX},${startAtEdgeY} L ${endAtGapX},${endAtGapY}`;

          calculatedTargets = {
            opacity: myChart.showLabels ? 1 : 0,
            groupTransform: `translate(${groupX}, ${groupY})`,
            indicatorPath: indicatorPath,
            textAlign: pos.align,
            lines: lines,
            boxWidth: boxWidth,
            boxHeight: boxHeight,
            boxX: boxXOffset,
            boxY: boxYOffset
          };
          placedLabelBoundingBoxes.push(candidateRect);
          break;
        }
      }
      labelTargetsMap.set(d1.id, calculatedTargets);
    });

    function checkCollision(candidateRect: any): boolean {
      for (const finalNode2 of finalData) {
        const otherPointRadius = finalNode2.canGrow ? effectiveLargeRadius : effectiveSmallRadius;
        const pointRect = { x: finalNode2.simx - otherPointRadius, y: finalNode2.simy - otherPointRadius, width: 2 * otherPointRadius, height: 2 * otherPointRadius };
        if (checkRectOverlap(candidateRect, pointRect)) return false;
      }
      for (const placedRect of placedLabelBoundingBoxes) {
        if (checkRectOverlap(placedRect, candidateRect)) return false;
      }
      return true;
    };
    function checkRectOverlap(rect1: any, rect2: any): boolean {
      return !(rect1.x >= rect2.x + rect2.width || rect2.x >= rect1.x + rect1.width ||
        rect1.y >= rect2.y + rect2.height || rect2.y >= rect1.y + rect1.height);
    }

    // --- APPLY UPDATES ---

    // 1. Update Text Content (Multi-line)
    mergedLabelGroupsForLabels.select(".point-source-label-text")
      .each(function (d: any) {
        const target = labelTargetsMap.get(d.id);
        const sel = d3.select(this);
        sel.text(null); // Clear existing
        if (target && target.lines) {
          const lineHeight = baseLabelFontSize * 1.2;
          // Start y offset to center the block vertically
          // If boxHeight is total height, we want to start at -boxHeight/2 + firstLineAscent?
          // Or simpler: just stack them starting from boxY + padding + ascent.
          // Since our group is at center, and boxY is -height/2.

          const startY = target.boxY + 4 + baseLabelFontSize; // +4 padding, +fontSize for baseline

          target.lines.forEach((line, i) => {
            sel.append("tspan")
              .attr("x", 0) // Relative to group, but we need to align it?
              // Actually, if text-anchor is set, x=0 works if we want to align to the anchor point.
              // But our box is calculated based on alignment.
              // If align is 'start', boxX is 0. x=0 is left edge of box + padding?
              // We need to adjust x based on alignment to keep it inside the box.

              .attr("x", () => {
                if (target.textAlign === 'start') return target.boxX + 4; // Left padding
                if (target.textAlign === 'end') return target.boxX + target.boxWidth - 4; // Right padding
                return target.boxX + target.boxWidth / 2; // Center
              })
              .attr("dy", i === 0 ? startY : lineHeight) // First line absolute-ish, others relative
              .text(line);
          });
        }
      })
      .attr("text-anchor", (d: any) => labelTargetsMap.get(d.id)?.textAlign ?? "middle");

    // 2. Update Background Box
    mergedLabelGroupsForLabels.select(".point-label-bg")
      .attr("x", (d: any) => labelTargetsMap.get(d.id)?.boxX ?? 0)
      .attr("y", (d: any) => labelTargetsMap.get(d.id)?.boxY ?? 0)
      .attr("width", (d: any) => labelTargetsMap.get(d.id)?.boxWidth ?? 0)
      .attr("height", (d: any) => labelTargetsMap.get(d.id)?.boxHeight ?? 0)
      .style("visibility", myChart.props.Labelbackground ? "visible" : "hidden")
      .transition("labelBgOpacity").duration(750)
      .attr("fill", (myChart.props.LabelbackgroundColor || "white"))
      .style("opacity", (d: any) => labelTargetsMap.get(d.id)?.opacity ?? 0); // Fade in/out with text

    // 3. Transition the position of the entire label group
    mergedLabelGroupsForLabels.transition("labelTransform").duration(750)
      .attr("transform", (d: any) => labelTargetsMap.get(d.id)?.groupTransform ?? "translate(0,0)");

    // 4. Separately transition the OPACITY of the text element
    mergedLabelGroupsForLabels.select(".point-source-label-text")
      .transition("labelTextOpacity").duration(750)
      .style("font-size", `${myChart.props.LabelfontSize}px`)
      .style("fill", (myChart.props.Labelcolor || "#333"))
      .style("opacity", (d: any) => labelTargetsMap.get(d.id)?.opacity ?? 0);

    // 5. Separately transition the OPACITY AND PATH of the indicator line
    mergedLabelGroupsForLabels.select(".point-label-indicator").lower()
      .transition("labelIndicator").duration(750)
      .style("opacity", (d: any) => labelTargetsMap.get(d.id)?.opacity ?? 0)
      .attr("d", (d: any) => labelTargetsMap.get(d.id)?.indicatorPath ?? "M0,0");
  }

  plotChart(renderWithMasterData: boolean = true) {
    this.known_source_colors = {} as Record<string, string>;
    this.known_kpi_colors = {} as Record<string, string>;
    this.myCategories.clear();
    this.haveSelectedPoints = false;
    this.isZoomedToSelection = false;

    // Need to fetch our data
    const myChart = this;
    const myClass = myChart.divId;

    // set master data structure to nothing
    this.masterData = [];
    let pointIdCounter = 0;

    this.ScatterPlotChartData.forEach((d: any) => {
      let my_lookback_values = d.periods;
      this.myCategories.add(d.kpi_group_name.toLowerCase());
      // my_lookback_values.pop()
      my_lookback_values = my_lookback_values.slice(-d["look_back_period"]);
      myChart.masterData.push(
        {
          id: `point-${pointIdCounter++}`,
          kpi_value: d["kpi_value"],
          kpi_key: d["kpi_key"],
          x: d["patient_volume"],
          y: Number(d["z_score"]),
          source_nm: d["source_name"] ? d["source_name"] : d["x_axis_value"],
          kpi_name: d["kpi_nm"],
          periods: my_lookback_values,
          lookback_period: d["look_back_period"],
          location: d["du_sp_location_name"],
          location_key: d["du_sp_location_key"],
          category: d["kpi_group_name"]?.toLowerCase(),
          current_date: d["current_date"],
          upper_control_limit: d["upper_control_limit"],
          lower_control_limit: d["lower_control_limit"],
          lower_threshold: d["upper_threshold"],
          upper_threshold: d["lower_threshold"],
          no_of_std_deviations: d["no_of_std_deviations"],
          x_axis_value: d["x_axis_value"] ? d["x_axis_value"] : d["source_name"],
          x_axis_key: d["x_axis_key"],
          y_axis_value: d["y_axis_value"] ? d["y_axis_value"] : d["kpi_nm"],
          y_axis_key: d["y_axis_key"] ? d["y_axis_key"] : d["kpi_key"]
        }
      );
    });

    // convert my catergory set to an array
    this.getSelectedCategories();

    this.categoryColorsMap = {};
    // set colors for selectedCategories
    for (let x of this.selectedCategories) {
      // If category color not set then set the color
      if (!this.categoryColorsMap[x]) {
        const count = Object.keys(this.categoryColorsMap).length
        // only add more colors if needed
        if (count >= this.categoryColors.length) {
          this.categoryColors.push(...this.getRandomDarkColor(20));
        }
        this.categoryColorsMap[x] = this.categoryColors[count];
      }
    }

    const mySvg: any = d3.select('#svg_' + myClass);

    myChart.margins.bottom = myChart.props.xAxisShow ? 30 : 5

    // Remove previous grid and dots on SVG
    // mySvg.selectAll(".grid").remove();
    mySvg.selectAll(".point-group").remove();

    this.width = mySvg.node().getBoundingClientRect().width;
    const height = myChart.props.chartHeight;

    mySvg.attr("width", this.width)
      .attr("height", height);



    myChart.masterData.forEach((d: any, index: number) => {
      // If source color not set then set the color
      // if (!this.known_source_colors[d.source_nm]) {
      //   this.known_source_colors[d.source_nm] = this.darkColors[index % this.darkColors.length];
      // }
      // If kpi color not set then set the color
      if (!this.known_kpi_colors[d.kpi_name]) {
        const kpiCount = Object.keys(this.known_kpi_colors).length
        // only add more colors if needed
        if (kpiCount >= this.darkColors.length) {
          this.darkColors.push(...this.getRandomDarkColor(20));
        }
        this.known_kpi_colors[d.kpi_name] = this.darkColors[kpiCount];
      }
    });
    this.yMax = d3.max(myChart.masterData, (d: any) => d.y) || 1;
    this.yMin = d3.min(myChart.masterData, (d: any) => d.y) || -1;
    // all values are the same so spread our yMax and yMin a little
    if (this.yMax == this.yMin) {
      this.yMax += 1
      this.yMin -= 1
    }

    let xMax = d3.max(myChart.masterData, (d: any) => d.x) || -Infinity;
    const xExtent = d3.extent(myChart.masterData, (d: any) => d.x);
    const chartHeight = height - this.margins.top - this.margins.bottom;

    // Extract unique source names in descending sorted order via patient volume
    const sourcesSortedByVolume = Array.from(
      new Map(myChart.masterData.map((d: any) => [
        d.x_axis_value,
        { source: d.x_axis_value, x: d.x }
      ]))
        .values()
    )
    // .sort((a:any, b:any) =>{
    //   if (b.x !== a.x) {
    //     return b.x - a.x;
    //   }
    //   // If x values are the same, compare source alphabetically
    //   return a.source.localeCompare(b.source);
    // });

    this.sources = sourcesSortedByVolume.map((item: any) => item.source);
    console.log(this.sources, "test");


    // Set x and y scales
    // Use the linear x scale for a normal scatter plot
    // const xScale = d3.scaleLinear().domain([0, reducer.maxVolume]).range([this.margins.left, this.width - this.margins.right]);
    // const xScale = d3.scaleLinear().domain([0, reducer.maxVolume]).range([this.margins.left, this.width - this.margins.right]);
    this.xScale = d3.scaleBand()
      .domain(this.sources)
      .range([this.margins.left, this.width])
    // .padding(0.5); // Even spacing

    const xScaleAll = d3.scaleLinear().domain([0, xMax]).range([this.margins.left, this.width - this.margins.right]);
    // give our range some buffers so points do not show up on the edge. Using 2% buffers right now
    this.yScale = d3.scaleLinear().domain([this.yMin, this.yMax]).nice().range([height - this.margins.bottom, this.margins.top]);
    const yScaleAll = d3.scaleLinear().domain([0, this.yMax]).range([this.margins.brush, 0]);
    const yScaleBrush = d3.scaleLinear().domain([0, this.yMax]).range([this.margins.brush, 0]);

    this.subXScale = d3.scaleBand();
    if (this.selectedCategories.length != 0) {
      // Define Sub X Scale (Subcategories within `source_nm`)
      myChart.subXScale = d3.scaleBand()
        .domain(this.selectedCategories) // Fixed subcategory labels
        .range([0, this.xScale.bandwidth()]); // Fit within each `source_nm` band
    }
    // Define color scale for each subcategory
    this.colorScale = d3.scaleOrdinal()
      .domain(this.selectedCategories)
      .range(this.selectedCategories.map((key: string) => this.categoryColorsMap[key]));
    // Used to keep track of which subcategory has been selected
    myChart.subXScaleMap = new Map<string, d3.ScaleBand<string>>();


    // setup color scales
    const maxY = d3.max(myChart.masterData, d => (d.y)) ?? 5;
    const minY = d3.min(myChart.masterData, d => (d.y)) ?? 5;
    this.greenFade = d3.scaleLinear()
      .domain([0, 2])       // Closer to 0 = stronger green
      .range([1, .2])
      .clamp(true);

    this.redFade = d3.scaleLinear()
      .domain([2, maxY])    // Further from +2 = stronger red
      .range([0.2, 1])
      .clamp(true);

    this.blueFade = d3.scaleLinear()
      .domain([-2, minY])    // Further from -2 = stronger blue
      .range([0.2, 1])
      .clamp(true);

    const margins = this.margins;
    // const width = this.width;


    this.xAxis = d3.axisBottom(this.xScale)
      .tickSize(0);         // no tick lines
    // .tickSize(-(height - this.margins.bottom - this.margins.top))
    // // .tickFormat(d3.format(""))
    // .tickSizeOuter(0)

    this.yAxis = d3.axisLeft(this.yScale)
      .tickFormat(() => "") // no text shown
      .tickSize(0);         // no tick lines 
    // .tickSizeInner(-(this.width - this.margins.left - this.margins.right))
    // .tickSizeOuter(0)

    // TODO:
    mySvg.select(".xAxis" + myClass)
      .attr("visibility", myChart.props.xAxisShow ? 'visible' : 'hidden')
      .attr("transform", `translate(0, ${height - this.margins.bottom})`) // flush to chart
      // .attr("stroke", gray)
      .call(this.xAxis)
      .call((g: any) => {
        g.selectAll(".tick text")
          .attr("dy", "1.5em") // Add padding below ticks
          .attr("color", myChart.props.xAxisColor || "#101D42")
          .attr("font-size", (myChart.props.xAxisFontSize || 12) + "px")
          .attr("font-weight", myChart.props.xAxisBold ? "bold" : "normal")
          .attr("font-family", "Poppins")
        g.select(".domain")
          .attr("stroke", myChart.gray); // set color 
      });

    // Line that goes across at y = 0 
    mySvg.select(".zeroLine")
      .attr("x1", margins.left)
      .attr("x2", myChart.width)
      .attr("y1", myChart.yScale(0))
      .attr("y2", myChart.yScale(0))
      .attr("stroke", myChart.gray)
      .attr("stroke-width", 1)
      .lower();


    // The word 'Mean' that stick to the line going across at y=0
    mySvg.select(".zeroLineLabel")
      .attr("class", "zeroLineLabel")
      .attr("x", margins.left - 30) // adjust as needed
      .attr("y", myChart.yScale(0) + 10)
      .attr("fill", myChart.gray)
      .attr("font-size", "12px")
      .attr("font-family", "Poppins")
      .attr("transform", `rotate(-90, ${margins.left - 30}, ${myChart.yScale(0) + 10})`) // rotate around the label’s x,y
      .text("Mean");


    const yZeroPos = myChart.yScale(0);
    // Define the visible boundaries of your chart
    const chartTop = myChart.margins.top;
    const chartBottom = myChart.props.chartHeight - myChart.margins.bottom;
    // Y is either the position of y=0 or the top of the chart, whichever is lower (larger value).
    const boxY = Math.max(yZeroPos, chartTop);

    // Determine the correct height.
    // It's the distance from the calculated top (boxY) to the chart bottom.
    // Use Math.max(0, ...) to prevent negative height if the box is entirely off-screen.
    const boxHeight = Math.max(0, chartBottom - boxY);

    mySvg.select(".zeroBox")
      .attr("x", myChart.margins.left)
      .attr("y", boxY)
      .attr("width", myChart.width - myChart.margins.left)
      .attr("height", boxHeight)
      .attr("fill", myChart.gray)
      .attr("opacity", 0.25)
      .lower();

    // gridlines next to each source
    mySvg.selectAll(".x-gridline")
      .data(this.sources)
      .join("line")
      .attr("class", "x-gridline")
      .attr("x1", (d: any) => (myChart.xScale(d) ?? 0) + myChart.xScale.bandwidth()) // RIGHT edge
      .attr("x2", (d: any) => (myChart.xScale(d) ?? 0) + myChart.xScale.bandwidth()) // RIGHT edge
      .attr("y1", margins.top)
      .attr("y2", height - margins.bottom)
      .attr("stroke", myChart.gray)
      .attr("stroke-width", 1)
      .attr("stroke-dasharray", "10 8");

    // Y axis
    mySvg.select(".yAxis" + myClass)
      .attr("transform", `translate(${this.margins.left},0)`)
      .call(myChart.yAxis)
      // Change color of Axis
      .select(".domain")
      .attr("stroke", myChart.gray);

    // Add "Spike" at the top of y Axis
    mySvg.select(".spike-label")
      .attr("x", - 8) // horizontal offset from the axis
      .attr("y", margins.top)   // top of chart
      .attr("dy", "-0.5em")  // nudge it slightly above
      .attr("text-anchor", "end")
      .attr("fill", myChart.gray)
      .attr("font-size", "12px")
      .attr("font-family", "Poppins")
      // Check if there are any spike values
      .style('visibility', this.masterData.some(item => item.y > this.upperBound) ? 'visible' : 'hidden')
      .text("Spike");

    // Check if there are any dip values
    // Add "Dip" at the bottom of y axis
    mySvg.select(".dip-label")
      .attr("x", -10)
      .attr("y", height - margins.bottom)
      .attr("dy", "1em")  // nudge it slightly below
      .attr("text-anchor", "end")
      .attr("fill", myChart.gray)
      .attr("font-size", "12px")
      .attr("font-family", "Poppins")
      .style('visibility', this.masterData.some(item => item.y < this.lowerBound) ? 'visible' : 'hidden')
      .text("Dip");


    // Add gradient bar next to chart
    const defs = mySvg.select("defs");

    const gradient = defs.append("linearGradient")
      .attr("id", "yAxisGradient")
      .attr("x1", "0%")
      .attr("x2", "0%")
      .attr("y1", "0%")
      .attr("y2", "100%");

    const barX = margins.left - 25; // Adjust based on layout
    const barWidth = 7;
    const numSteps = 11;
    const gap = 4;
    const totalGaps = (numSteps - 1) * gap;
    const stepHeight = (chartHeight - totalGaps) / numSteps;


    const stepData = d3.range(numSteps).map(i => {
      const yPos = margins.top + i * (stepHeight + gap);
      const yVal = myChart.yScale.invert(yPos + stepHeight / 2); // Get midpoint of step
      return {
        y: yPos,
        color: myChart.getStepColor(yVal)
      };
    });

    // Gradient bars next to the y axis
    mySvg.selectAll(".y-gradient-step")
      .data(stepData)
      .join("rect")
      .attr("class", "y-gradient-step")
      .attr("x", barX)
      .attr("y", (d: any) => d.y)
      .attr("width", barWidth)
      .attr("height", stepHeight)
      .attr("fill", (d: any) => d.color)
      .attr("rx", 1.5)  // horizontal radius
      .attr("ry", 1.5);  // vertical radius


    const tooltip = d3.select("#scatter_plot")
      .append("div")
      .style("opacity", 0)
      .attr("class", "tooltip")
      .style("position", "absolute") // Absolute positioning to follow the cursor
      .style("background-color", "white")
      .style("border", "solid")
      .style("border-width", "1px")
      .style("border-radius", "5px")
      .style("padding", "10px");

    // used for tooltip that shows up for long legend labels
    mySvg.select('.wrapTooltipRect' + myClass)
      .attr('rx', 2)
      .attr('ry', 2)
      .attr('height', 15)
      .attr('fill', '#343435')
      .attr('background', 'none');


    mySvg.select('.wrapTooltipLabel' + myClass)
      .attr('font-family', 'Poppins')
      .attr('font-weight', '500')
      .attr('font-size', '10')
      .attr('fill', 'white')


    this.selectedPointsData = this.masterData;
    // useful for when we need to replot our chart for going in and out of fullscreen
    if (renderWithMasterData) {
      this.displayData = this.masterData;
    }
    // plot the initial points and background bands on the chart using our full data structure
    if (this.displayData.length > 800) {
      // this.placePointsWithForce = false;
      this.legendFilter.push("normal"); // add to our legend filter
      // try showing chart without normal points
      this.filterPointsViaLegend();

    }
    // plot points normally
    else {
      if (!renderWithMasterData) this.updateScalesAndDomains();
      this.renderPointsandBackgroundBands(this.displayData);
    }
    // this.updateScalesAndDomains();

    // Set theme which updates the left legend
    this.changeChartTheme(this.current_theme);

    // Mouse button logic
    let mouseButtonVisibility = false;
    const zoomOut = d3.select(".zoom-out")
      .on("click", (event: any) => {
        // resest zoom
        myChart.resetZoom(true);
        this.changeChartTheme(this.current_theme);
        mouseButtonVisibility = false;
        zoomOut.style('visibility', 'hidden');
        zoomIn.style('visibility', 'hidden');
        compareIconBtn.style('visibility', 'hidden');
        heatmapIconBtn.style('visibility', 'hidden');
      });
    const zoomIn = d3.select(".zoom-in")
      .on("click", (event: any) => {
        // Now zoom into the chart
        mouseButtonVisibility = false;
        // we are now zoomed in
        myChart.isZoomedToSelection = true;
        this.zoomIntoSelectedPoints(this.getSelectedPointsData(this.selectedPoints));
        zoomOut.style('visibility', 'hidden');
        zoomIn.style('visibility', 'hidden');
        compareIconBtn.style('visibility', 'hidden');
        heatmapIconBtn.style('visibility', 'hidden');
      });

    const compareIconBtn = d3.select(".compareIconBtn")
      .on("click", (event: any) => {
        // resest zoom
        myChart.compareClick("route");
        zoomOut.style('visibility', 'hidden');
        zoomIn.style('visibility', 'hidden');
        compareIconBtn.style('visibility', 'hidden');
        heatmapIconBtn.style('visibility', 'hidden');
      });
    const heatmapIconBtn = d3.select(".heatmapIconBtn")
      .on("click", (event: any) => {
        // resest zoom
        this.showDataHeatMap();
        zoomOut.style('visibility', 'hidden');
        zoomIn.style('visibility', 'hidden');
        compareIconBtn.style('visibility', 'hidden');
        heatmapIconBtn.style('visibility', 'hidden');
      });

    // Lasso stuff
    const lassoLayer = mySvg.select(".lasso-layer");
    lassoLayer.lower();
    let lassoPoints: [number, number][] = [];
    let isDragging = false;
    let startX: number, startY: number = 0
    const lasso = d3.drag()
      .on("start", (event: any) => {
        // --- START OF ACTION ---
        // 1. Hide any buttons that are currently open. This handles closing the menu.
        myChart.hideMouseButtons();
        // mouseButtonVisibility = false;

        // 2. Prepare for a potential drag action.
        isDragging = false;
        startX = event.x;
        startY = event.y;

        // Reset lasso and selections (if not holding shift)
        const isShiftPressed = event.sourceEvent?.shiftKey || false;
        if (!isShiftPressed) {
          this.selectedPoints = [];
          this.updateHeatMapData(this.selectedPoints);
          this.current_theme == "anomaly" ? this.setAnomalyThemeColors() : this.setKPIThemeColors();
          lassoPoints = [];
          lassoLayer.selectAll("path").remove();
        }
      })
      .on("drag", (event: any) => {
        // --- DRAGGING IN PROGRESS ---
        // 1. Check if we've moved far enough to be considered a "drag"
        if (!isDragging && (Math.abs(event.x - startX) > 5 || Math.abs(event.y - startY) > 5)) {
          isDragging = true; // It's officially a drag, not a click.
          lassoPoints = []; // Reset previous lasso selection
          lassoLayer.selectAll("path").remove(); // Clear old lasso
        }

        // 2. If we aren't dragging, do nothing.
        if (!isDragging) return;

        // 3. Draw the lasso. Notice there are NO calls to showMouseButtons() here.
        const [x, y] = getPointerCoords(event.sourceEvent ?? event, mySvg.node());
        lassoPoints.push([x, y]);

        lassoLayer.selectAll("path").remove();
        lassoLayer.append("path")
          .attr("d", `M${lassoPoints.map(d => d.join(",")).join("L")}Z`)
          .attr("fill", "rgba(48, 129, 252, 0.1)")
          .attr("stroke", '#2a78ed')
          .attr("stroke-width", 1)
          .attr('stroke-dasharray', '6.0');
      })
      .on("end", (event: any) => {
        // --- ACTION COMPLETE: THE DECISION POINT ---
        if (isDragging) {
          // ACTION WAS A DRAG:
          // Finish the lasso selection...
          lassoPoints = getPointsInsideLasso(lassoPoints, lassoLayer);

          // ...and now, finally, show the buttons.
          myChart.showMouseButtons(event);
          mouseButtonVisibility = true;

          this.selectedPoints.forEach((d: any) => {
            d3.select(d)
              .attr("style", "stroke: #bfc200ff; stroke-width: 4px; stroke-dasharray: 3,3;");
          });
        } else {
          // ACTION WAS A CLICK (drag never started):
          // This is where we re-introduce the toggle.
          // We flip the previous visibility state.
          mouseButtonVisibility = !mouseButtonVisibility;
          this.haveSelectedPoints = false;

          // And apply the new state (either show or hide).
          mouseButtonVisibility ? myChart.showMouseButtons(event) : myChart.hideMouseButtons();
        }

        // Reset the dragging flag for the next action.
        isDragging = false;
      });

    mySvg.call(lasso as unknown as (selection: d3.Selection<SVGSVGElement, unknown, HTMLElement, any>) => void);

    // check if we need to redraw our xaxis because the source names are too close together
    let redrawChart = false;
    redrawChart = myChart.checkWidth();
    if (redrawChart) myChart.resetZoom();

    // Change the stylings of selected points and update our selectedPoints data structure
    const getPointsInsideLasso = (lassoPolygon: [number, number][], lassoLayer: any): [number, number][] => {
      let pointsInsideLasso: any[] = []
      let pointsInsideLassoData: any[] = []
      d3.selectAll(".data_point").each(function (d: any) {
        let cx: number, cy: number;
        if (myChart.selectedCategories.length != 0) {
          // [cx, cy] = [parseFloat(d3.select(this).attr("cx")), parseFloat(d3.select(this).attr("cy"))];
          [cx, cy] = [d.simx, d.simy];
        }
        else {
          [cx, cy] = [myChart.xScale(d.x_axis_value)! + myChart.xScale.bandwidth() / 2, myChart.yScale(d.y)];
        }
        const isInside = d3.polygonContains(lassoPolygon, [cx, cy]);

        if (isInside) {
          pointsInsideLasso.push(this);
          pointsInsideLassoData.push(d);
        }
      });

      this.selectedPoints = this.selectedPoints.concat(pointsInsideLasso);
      if (this.selectedPoints.length > 0) {
        this.haveSelectedPoints = true;
      }
      else {
        this.haveSelectedPoints = false;
      }
      this.updateHeatMapData(this.selectedPoints);

      return lassoPoints;

    }

    function getPointerCoords(evt: any, container: HTMLElement): [number, number] {
      const rect = container.getBoundingClientRect();
      if (evt.touches?.length) {
        const touch = evt.touches[0];
        return [touch.clientX - rect.left, touch.clientY - rect.top];
      }
      return d3.pointer(evt, container);
    }
  }

  /**
 * Displays and animates the context buttons, spawning from the cursor's location.
 * @param event The mouse event used to determine the cursor's position.
 * @param isPointerEvent A flag to handle different event types if necessary.
 */
  showMouseButtons(event: MouseEvent, isPointerEvent: boolean = false): void {
    const buttons = {
      zoomOut: d3.select(".zoom-out"),
      zoomIn: d3.select(".zoom-in"),
      compare: d3.select(".compareIconBtn"),
      heatmap: d3.select(".heatmapIconBtn")
    };

    const chartContainer = d3.select(this.scatterPlotContainer.nativeElement).node() as HTMLElement;
    if (!chartContainer) return;

    // 1. Determine cursor position and container dimensions
    const chartRect = chartContainer.getBoundingClientRect();
    const buttonSize = 28; // The width/height of a single button
    const cursorX = isPointerEvent ? event.offsetX : event.x;
    const cursorY = isPointerEvent ? event.offsetY : event.y;

    // 2. Define button offsets and pivot based on cursor quadrant
    const offsets = {
      zoomIn: { x: -45, y: 75 },
      zoomOut: { x: -45, y: 105 },
      compare: { x: -15, y: 50 },
      heatmap: { x: 15, y: 50 }
    };
    if (cursorX < chartRect.width / 2) {
      offsets.zoomIn.x *= -1;
      offsets.zoomOut.x *= -1;
    }
    if (cursorY < chartRect.height / 2) {
      offsets.compare.y = 125;
      offsets.heatmap.y = 125;
    }

    // 3. Calculate group constraints to keep all buttons in view
    const allOffsets = Object.values(offsets);
    const minX = Math.min(...allOffsets.map(o => o.x));
    const maxX = Math.max(...allOffsets.map(o => o.x));
    const minY = Math.min(...allOffsets.map(o => o.y));
    const maxY = Math.max(...allOffsets.map(o => o.y));

    const groupLeft = cursorX + minX;
    const groupTop = cursorY + minY;
    const groupWidth = (maxX - minX) + buttonSize;
    const groupHeight = (maxY - minY) + buttonSize;

    let shiftX = 0;
    let shiftY = 0;
    if (groupLeft < 0) shiftX = -groupLeft;
    else if (groupLeft + groupWidth > chartRect.width) shiftX = chartRect.width - (groupLeft + groupWidth);
    if (groupTop < 0) shiftY = -groupTop;
    else if (groupTop + groupHeight > chartRect.height) shiftY = chartRect.height - (groupTop + groupHeight);

    // 4. Animate each button
    if (this.isZoomedToSelection) {
      buttons.zoomOut.style('visibility', 'visible');
    }
    if (this.haveSelectedPoints) {
      buttons.zoomIn.style('visibility', 'visible');
      buttons.compare.style('visibility', 'visible');
      buttons.heatmap.style('visibility', 'visible');
    }

    const animateButton = (button: any, offset: { x: number; y: number; }) => {
      const finalX = cursorX + offset.x + shiftX;
      const finalY = cursorY + offset.y + shiftY;

      button
        .style('left', `${cursorX}px`)
        .style('top', `${cursorY}px`)
        .style('opacity', 0)
        .style('transform', 'scale(0)')
        .transition()
        .duration(250)
        .ease(d3.easeCubicOut)
        .style('left', `${finalX}px`)
        .style('top', `${finalY}px`)
        .style('opacity', 1)
        .style('transform', 'scale(1)');
    };
    if (this.isZoomedToSelection) {
      animateButton(buttons.zoomOut, offsets.zoomOut);
    }
    else {
      // we are in the top half of chart
      if (cursorY < chartRect.height / 2) {
        offsets.zoomIn.y = 105;
      }
    }
    if (this.haveSelectedPoints) {
      animateButton(buttons.zoomIn, offsets.zoomIn);
      animateButton(buttons.compare, offsets.compare);
      animateButton(buttons.heatmap, offsets.heatmap);
    }
  }

  /**
   * Hides and animates the context buttons, collapsing them to their collective center.
   * This function does not require an event, as it calculates the destination
   * based on the buttons' current positions.
   */
  hideMouseButtons(): void {
    const buttonNodes = [
      d3.select(".zoom-out"),
      d3.select(".zoom-in"),
      d3.select(".compareIconBtn"),
      d3.select(".heatmapIconBtn")
    ];

    // 1. Find the bounding box of all currently visible buttons
    let minX = Infinity, minY = Infinity, maxX = -Infinity, maxY = -Infinity;
    let visibleButtons = 0;

    buttonNodes.forEach(button => {
      if (!button.node() || button.style('visibility') === 'hidden') return;

      const left = parseFloat(button.style('left'));
      const top = parseFloat(button.style('top'));

      if (left < minX) minX = left;
      if (left > maxX) maxX = left;
      if (top < minY) minY = top;
      if (top > maxY) maxY = top;
      visibleButtons++;
    });

    // If no buttons are visible, do nothing.
    if (visibleButtons === 0) return;

    // 2. Calculate the center point of the button group
    const centerX = minX + (maxX - minX) / 2;
    const centerY = minY + (maxY - minY) / 2;

    // 3. Animate each button to collapse into the calculated center point
    buttonNodes.forEach(button => {
      button
        .transition()
        .duration(200)
        .ease(d3.easeCubicIn)
        .style('left', `${centerX}px`)
        .style('top', `${centerY}px`)
        .style('opacity', 0)
        .style('transform', 'scale(0)')
        .on('end', function () {
          // Use a standard function to maintain 'this' context if needed by D3
          d3.select(this).style('visibility', 'hidden');
        });
    });
  }


  private showTooltip(myData: any, myX: any, myY: any, chartWidth: any, chartHeight: any): void {
    this.mytooltipData = myData;
    this.tooltipTurn = 0;
    this.tooltipHeight = 0;
    const distanceFromBottom = chartHeight - myY;
    this.tooltipHeight = chartHeight - myY;

    // account for horizontal scroll
    const scrollContainer = d3.select(".scrollcss").node() as HTMLElement;
    // const scrollRight = scrollContainer.scrollWidth - scrollContainer.scrollLeft
    // this.tooltipTurn = chartWidth - (myX + scrollRight);
    // know how close we are the the edge by using the viewport width
    this.tooltipTurn = scrollContainer.clientWidth - (myX - scrollContainer.scrollLeft);

    if (this.tooltipHeight < 200) {
      // bottom tooltip
      d3.select("#d3WordCloudTooltip")
        .style('visibility', 'visible')
        .style('position', 'absolute')
        .style('bottom', (distanceFromBottom - 80) + 'px')
        .style('top', 'unset')
    }
    else if (this.tooltipHeight >= 200) {
      // top tooltip
      d3.select("#d3WordCloudTooltip")
        .style('visibility', 'visible')
        .style('position', 'absolute')
        .style('top', (myY + 20) + 'px')
        .style('bottom', 'unset')
    }

    // tooltip to the left of the mouse
    if (this.tooltipTurn < 250) {
      d3.select("#d3WordCloudTooltip")
        .style('visibility', 'visible')
        .style('position', 'absolute')
        .style('right', (this.tooltipTurn + 35) + 'px')
        .style('left', 'unset')
      // .style('top', myY + 40 + 'px')
      // .style('bottom', 'unset')
    }
    // make sure to take scroll into account
    // Tool tip to to the right of mouse
    else if (this.tooltipTurn >= 250) {
      d3.select("#d3WordCloudTooltip")
        .style('visibility', 'visible')
        .style('position', 'absolute')
        .style('left', (myX - scrollContainer.scrollLeft + 35) + 'px')
        .style('right', 'unset')
      // .style('top', (  myY + 40) + 'px')
      // .style('bottom', 'unset')
    }
    this.tooltip = true;
  }

  private hideTooltip(): void {
    this.tooltip = false;
    d3.select("#d3WordCloudTooltip")
      .style('visibility', 'hidden');
  }

  getStepColor = (yVal: number) => {
    if (yVal > this.upperBound) {
      return `rgba(232, 110, 84, ${this.redFade(yVal)})`; // red
    }
    else if (yVal < this.lowerBound) {
      return `rgba(102, 90, 222, ${this.blueFade(yVal)})`; // blue
    }
    else {       // in between upper and lower bounds
      return `rgba(45, 200, 135, ${this.greenFade(yVal)})`; // green
    }
  };

  getSelectedPointsData(selectedPointsDOMElements: SVGCircleElement[]) {
    return selectedPointsDOMElements.map((d: any) => d.__data__);
  }

  getSelectedCategories() {
    this.selectedCategories = Array.from(this.myCategories);
    this.selectedCategories.sort();

  }

  getSortedSourcesByVolume(chartData: any[]): string[] {
    // Extract unique source names in descending sorted order via patient volume
    const sourcesSortedByVolume = Array.from(
      new Map(chartData.map((d: any) => [
        d.x_axis_value,
        { source: d.x_axis_value, x: d.x }
      ])).values()
    )
    // .sort((a: any, b: any) => {
    //   if (b.x !== a.x) {
    //     return b.x - a.x;
    //   }
    //   // If x values are the same, compare source alphabetically
    //   return a.source.localeCompare(b.source);
    // });

    return sourcesSortedByVolume.map((item: any) => item.source);
  }

  /**
 * Renders data points (circles) and their source labels if space permits.
 */
  // Helper for truncating text
  private truncateText(text: string, maxLength: number): string {
    if (text.length > maxLength) {
      return text.substring(0, maxLength - 3) + "...";
    }
    return text;
  }

  getRandomColor(count: any) {
    let shades: any = [];
    for (let i = 0; i < count; i++) {
      var length = 6;
      var chars = '0123456789ABCDEF';
      var hex = '#';
      while (length--) hex += chars[(Math.random() * 16) | 0];
      const shade = hex;
      shades.push(shade);
    }
    return shades;
  }
  getRandomDarkColor(count: number, type: string = "dark"): string[] {
    const shades: string[] = [];

    for (let i = 0; i < count; i++) {
      // Red, Green, Blue values between 0 and 150 for darker tones
      const r = Math.floor(Math.random() * 150);
      const g = Math.floor(Math.random() * 150);
      const b = Math.floor(Math.random() * 150);

      // Convert to hex and ensure two-digit format
      const toHex = (val: number) => val.toString(16).padStart(2, '0');
      const hex = `#${toHex(r)}${toHex(g)}${toHex(b)}`;

      shades.push(hex);
    }

    return shades;
  }
  applyChartPreferences(event: any) {


    if (event) {
      // X-Axis
      this.props.xAxisShow = event.xAxis.show;
      this.props.xAxisFontSize = event.xAxis.fontSize;
      this.props.xAxisBold = event.xAxis.bold;
      this.props.xAxisColor = event.xAxis.color;

      // Y-Axis
      if (event.circeValve) {
        this.props.circeValveShow = event.circeValve.show;
        this.props.circeValveFontSize = event.circeValve.fontSize;
        this.props.circeValveBold = event.circeValve.bold;
        this.props.circeValveColor = event.circeValve.color;
        this.useForce = event.circeValve.useForce;
        this.showLabels = event.circeValve.showLabels;
        this.props.LabelfontSize = event.circeValve.LabelfontSize
        this.props.Labelcolor = event.circeValve.Labelcolor
        this.props.Labelbackground = event.circeValve.Labelbackground
        this.props.LabelbackgroundColor = event.circeValve.LabelbackgroundColor
      }

      //  Legend
      // this.props.legendShow = event.legend.show;
      // this.props.legendFontSize = event.legend.fontSize;
      // this.props.legendColor = event.legend.color;
      // this.props.legendPosition = event.legend.position;

    }

    setTimeout(() => {
      this.plotChart();
    }, 50);
  }
}